var items = {
  "block.minecraft.acacia_button": "Akazieholzchnopf",
  "block.minecraft.acacia_door": "Akazieholztür",
  "block.minecraft.acacia_fence": "Akazieholzhaag",
  "block.minecraft.acacia_fence_gate": "Akazieholzhaagtor",
  "block.minecraft.acacia_hanging_sign": "Akazieholzhängeschild",
  "block.minecraft.acacia_leaves": "Akazielaub",
  "block.minecraft.acacia_log": "Akaziestamm",
  "block.minecraft.acacia_planks": "Akazieholzbretter",
  "block.minecraft.acacia_pressure_plate": "Akazieholzdruckplatte",
  "block.minecraft.acacia_sapling": "Akaziesetzling",
  "block.minecraft.acacia_shelf": "Akazieholzregal",
  "block.minecraft.acacia_sign": "Akazieholzschild",
  "block.minecraft.acacia_slab": "Akazieholzstufe",
  "block.minecraft.acacia_stairs": "Akazieholzstäge",
  "block.minecraft.acacia_trapdoor": "Akazieholzfalltür",
  "block.minecraft.acacia_wall_hanging_sign": "Akazieholzwandhängeschild",
  "block.minecraft.acacia_wall_sign": "Akazieholzwandschild",
  "block.minecraft.acacia_wood": "Akazieholz",
  "block.minecraft.activator_rail": "Aktivierigsschine",
  "block.minecraft.air": "Luft",
  "block.minecraft.allium": "Zierlauch",
  "block.minecraft.amethyst_block": "Amethystblock",
  "block.minecraft.amethyst_cluster": "Amethysthuufe",
  "block.minecraft.ancient_debris": "Antike Schrott",
  "block.minecraft.andesite": "Andesit",
  "block.minecraft.andesite_slab": "Andesitstufe",
  "block.minecraft.andesite_stairs": "Andesitstäge",
  "block.minecraft.andesite_wall": "Andesitmur",
  "block.minecraft.anvil": "Amboss",
  "block.minecraft.attached_melon_stem": "Meloneranke",
  "block.minecraft.attached_pumpkin_stem": "Chürbisranke",
  "block.minecraft.azalea": "Azalee",
  "block.minecraft.azalea_leaves": "Azaleelaub",
  "block.minecraft.azure_bluet": "Porzellansternli",
  "block.minecraft.bamboo": "Bambus",
  "block.minecraft.bamboo_block": "Bambusblock",
  "block.minecraft.bamboo_button": "Bambuschnopf",
  "block.minecraft.bamboo_door": "Bambustür",
  "block.minecraft.bamboo_fence": "Bambushaag",
  "block.minecraft.bamboo_fence_gate": "Bambushaagtor",
  "block.minecraft.bamboo_hanging_sign": "Bambushängeschild",
  "block.minecraft.bamboo_mosaic": "Bambusmosaik",
  "block.minecraft.bamboo_mosaic_slab": "Bambusmosaikstufe",
  "block.minecraft.bamboo_mosaic_stairs": "Bambusmosaikstäge",
  "block.minecraft.bamboo_planks": "Bambusbretter",
  "block.minecraft.bamboo_pressure_plate": "Bambusdruckplatte",
  "block.minecraft.bamboo_sapling": "Bambussprössling",
  "block.minecraft.bamboo_shelf": "Bambusregal",
  "block.minecraft.bamboo_sign": "Bambusschild",
  "block.minecraft.bamboo_slab": "Bambusstufe",
  "block.minecraft.bamboo_stairs": "Bambusstäge",
  "block.minecraft.bamboo_trapdoor": "Bambusfalltür",
  "block.minecraft.bamboo_wall_hanging_sign": "Bambuswandhängeschild",
  "block.minecraft.bamboo_wall_sign": "Bambuswandschild",
  "block.minecraft.banner.base.black": "Vollständig schwarzes Feld",
  "block.minecraft.banner.base.blue": "Vollständig blaus Feld",
  "block.minecraft.banner.base.brown": "Vollständig brunes Feld",
  "block.minecraft.banner.base.cyan": "Vollständig türkises Feld",
  "block.minecraft.banner.base.gray": "Vollständig graus Feld",
  "block.minecraft.banner.base.green": "Vollständig grüens Feld",
  "block.minecraft.banner.base.light_blue": "Vollständig hellblaus Feld",
  "block.minecraft.banner.base.light_gray": "Vollständig hellgraus Feld",
  "block.minecraft.banner.base.lime": "Vollständig hellgrüens Feld",
  "block.minecraft.banner.base.magenta": "Vollständig magenta Feld",
  "block.minecraft.banner.base.orange": "Vollständig oranges Feld",
  "block.minecraft.banner.base.pink": "Vollständig rosa Feld",
  "block.minecraft.banner.base.purple": "Vollständig violetts Feld",
  "block.minecraft.banner.base.red": "Vollständig rots Feld",
  "block.minecraft.banner.base.white": "Vollständig wiisses Feld",
  "block.minecraft.banner.base.yellow": "Vollständig gelbs Feld",
  "block.minecraft.banner.border.black": "Schwarzes Bord",
  "block.minecraft.banner.border.blue": "Blaus Bord",
  "block.minecraft.banner.border.brown": "Bruns Bord",
  "block.minecraft.banner.border.cyan": "Türkises Bord",
  "block.minecraft.banner.border.gray": "Graus Bord",
  "block.minecraft.banner.border.green": "Grüens Bord",
  "block.minecraft.banner.border.light_blue": "Hellblaus Bord",
  "block.minecraft.banner.border.light_gray": "Hellgraus Bord",
  "block.minecraft.banner.border.lime": "Hellgrüens Bord",
  "block.minecraft.banner.border.magenta": "Magenta Bord",
  "block.minecraft.banner.border.orange": "Oranges Bord",
  "block.minecraft.banner.border.pink": "Rosa Bord",
  "block.minecraft.banner.border.purple": "Violetts Bord",
  "block.minecraft.banner.border.red": "Rots Bord",
  "block.minecraft.banner.border.white": "Wiisses Bord",
  "block.minecraft.banner.border.yellow": "Gelbes Bord",
  "block.minecraft.banner.bricks.black": "Feld schwarz gmuuret",
  "block.minecraft.banner.bricks.blue": "Feld blau gmuuret",
  "block.minecraft.banner.bricks.brown": "Feld brun gmuuret",
  "block.minecraft.banner.bricks.cyan": "Feld türkis gmuuret",
  "block.minecraft.banner.bricks.gray": "Feld grau gmuuret",
  "block.minecraft.banner.bricks.green": "Feld grüen gmuuret",
  "block.minecraft.banner.bricks.light_blue": "Feld hellblau gmuuret",
  "block.minecraft.banner.bricks.light_gray": "Feld hellgrau gmuuret",
  "block.minecraft.banner.bricks.lime": "Feld hellgrüen gmuuret",
  "block.minecraft.banner.bricks.magenta": "Feld magenta gmuuret",
  "block.minecraft.banner.bricks.orange": "Feld orange gmuuret",
  "block.minecraft.banner.bricks.pink": "Feld rosa gmuuret",
  "block.minecraft.banner.bricks.purple": "Feld violett gmuuret",
  "block.minecraft.banner.bricks.red": "Feld rot gmuuret",
  "block.minecraft.banner.bricks.white": "Feld wiiss gmuuret",
  "block.minecraft.banner.bricks.yellow": "Feld gelb gmuuret",
  "block.minecraft.banner.circle.black": "Schwarzi Chugle",
  "block.minecraft.banner.circle.blue": "Blaui Chugle",
  "block.minecraft.banner.circle.brown": "Bruni Chugle",
  "block.minecraft.banner.circle.cyan": "Türkisi Chugle",
  "block.minecraft.banner.circle.gray": "Graui Chugle",
  "block.minecraft.banner.circle.green": "Grüeni Chugle",
  "block.minecraft.banner.circle.light_blue": "Hellblaui Chugle",
  "block.minecraft.banner.circle.light_gray": "Hellgraui Chugle",
  "block.minecraft.banner.circle.lime": "Hellgrüeni Chugle",
  "block.minecraft.banner.circle.magenta": "Magenta Chugle",
  "block.minecraft.banner.circle.orange": "Orangi Chugle",
  "block.minecraft.banner.circle.pink": "Rosa Chugle",
  "block.minecraft.banner.circle.purple": "Violetti Chugle",
  "block.minecraft.banner.circle.red": "Roti Chugle",
  "block.minecraft.banner.circle.white": "Wiissi Chugle",
  "block.minecraft.banner.circle.yellow": "Gelbi Chugle",
  "block.minecraft.banner.creeper.black": "Schwarze Creeper",
  "block.minecraft.banner.creeper.blue": "Blaue Creeper",
  "block.minecraft.banner.creeper.brown": "Brune Creeper",
  "block.minecraft.banner.creeper.cyan": "Türkise Creeper",
  "block.minecraft.banner.creeper.gray": "Graue Creeper",
  "block.minecraft.banner.creeper.green": "Grüene Creeper",
  "block.minecraft.banner.creeper.light_blue": "Hellblaue Creeper",
  "block.minecraft.banner.creeper.light_gray": "Hellgraue Creeper",
  "block.minecraft.banner.creeper.lime": "Hellgrüene Creeper",
  "block.minecraft.banner.creeper.magenta": "Magenta Creeper",
  "block.minecraft.banner.creeper.orange": "Orange Creeper",
  "block.minecraft.banner.creeper.pink": "Rosa Creeper",
  "block.minecraft.banner.creeper.purple": "Violette Creeper",
  "block.minecraft.banner.creeper.red": "Rote Creeper",
  "block.minecraft.banner.creeper.white": "Wiisse Creeper",
  "block.minecraft.banner.creeper.yellow": "Gelbe Creeper",
  "block.minecraft.banner.cross.black": "Schwarzes Andreaschrüüz",
  "block.minecraft.banner.cross.blue": "Blaus Andreaschrüüz",
  "block.minecraft.banner.cross.brown": "Bruns Andreaschrüüz",
  "block.minecraft.banner.cross.cyan": "Türkises Andreaschrüüz",
  "block.minecraft.banner.cross.gray": "Graus Andreaschrüüz",
  "block.minecraft.banner.cross.green": "Grüens Andreaschrüüz",
  "block.minecraft.banner.cross.light_blue": "Hellblaus Andreaschrüüz",
  "block.minecraft.banner.cross.light_gray": "Hellgraus Andreaschrüüz",
  "block.minecraft.banner.cross.lime": "Hellgrüens Andreaschrüüz",
  "block.minecraft.banner.cross.magenta": "Magenta Andreaschrüüz",
  "block.minecraft.banner.cross.orange": "Oranges Andreaschrüüz",
  "block.minecraft.banner.cross.pink": "Rosa Andreaschrüüz",
  "block.minecraft.banner.cross.purple": "Violetts Andreaschrüüz",
  "block.minecraft.banner.cross.red": "Rots Andreaschrüüz",
  "block.minecraft.banner.cross.white": "Wiisses Andreaschrüüz",
  "block.minecraft.banner.cross.yellow": "Gelbes Andreaschrüüz",
  "block.minecraft.banner.curly_border.black": "Schwarzes Spickelbord",
  "block.minecraft.banner.curly_border.blue": "Blaus Spickelbord",
  "block.minecraft.banner.curly_border.brown": "Bruns Spickelbord",
  "block.minecraft.banner.curly_border.cyan": "Türkises Spickelbord",
  "block.minecraft.banner.curly_border.gray": "Graus Spickelbord",
  "block.minecraft.banner.curly_border.green": "Grüens Spickelbord",
  "block.minecraft.banner.curly_border.light_blue": "Hellblaus Spickelbord",
  "block.minecraft.banner.curly_border.light_gray": "Hellgraus Spickelbord",
  "block.minecraft.banner.curly_border.lime": "Hellgrüens Spickelbord",
  "block.minecraft.banner.curly_border.magenta": "Magenta Spickelbord",
  "block.minecraft.banner.curly_border.orange": "Oranges Spickelbord",
  "block.minecraft.banner.curly_border.pink": "Rosa Spickelbord",
  "block.minecraft.banner.curly_border.purple": "Violetts Spickelbord",
  "block.minecraft.banner.curly_border.red": "Rots Spickelbord",
  "block.minecraft.banner.curly_border.white": "Wiisses Spickelbord",
  "block.minecraft.banner.curly_border.yellow": "Gelbes Spickelbord",
  "block.minecraft.banner.diagonal_left.black": "Schwarz schräglinks teilt",
  "block.minecraft.banner.diagonal_left.blue": "Blau schräglinks teilt",
  "block.minecraft.banner.diagonal_left.brown": "Brun schräglinks teilt",
  "block.minecraft.banner.diagonal_left.cyan": "Türkis schräglinks teilt",
  "block.minecraft.banner.diagonal_left.gray": "Grau schräglinks teilt",
  "block.minecraft.banner.diagonal_left.green": "Grüen schräglinks teilt",
  "block.minecraft.banner.diagonal_left.light_blue": "Hellblau schräglinks teilt",
  "block.minecraft.banner.diagonal_left.light_gray": "Hellgrau schräglinks teilt",
  "block.minecraft.banner.diagonal_left.lime": "Hellgrüen schräglinks teilt",
  "block.minecraft.banner.diagonal_left.magenta": "Magenta schräglinks teilt",
  "block.minecraft.banner.diagonal_left.orange": "Orange schräglinks teilt",
  "block.minecraft.banner.diagonal_left.pink": "Rosa schräglinks teilt",
  "block.minecraft.banner.diagonal_left.purple": "Violett schräglinks teilt",
  "block.minecraft.banner.diagonal_left.red": "Rot schräglinks teilt",
  "block.minecraft.banner.diagonal_left.white": "Wiiss schräglinks teilt",
  "block.minecraft.banner.diagonal_left.yellow": "Gelb schräglinks teilt",
  "block.minecraft.banner.diagonal_right.black": "Schwarz schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.blue": "Blau schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.brown": "Brun schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.cyan": "Türkis schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.gray": "Grau schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.green": "Grüen schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.light_blue": "Hellblau schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.light_gray": "Hellgrau schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.lime": "Hellgrüen schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.magenta": "Magenta schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.orange": "Orange schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.pink": "Rosa schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.purple": "Violett schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.red": "Rot schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.white": "Wiiss schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.yellow": "Gelb schrägrechts teilt",
  "block.minecraft.banner.diagonal_up_left.black": "Schwarz schrägrechts teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.blue": "Blau schrägrechts teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.brown": "Brun schrägrechts teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.cyan": "Türkis schrägrechts teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.gray": "Grau schrägrechts teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.green": "Grüen schrägrechts teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Hellblau schrägrechts teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Hellgrau schrägrechts teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.lime": "Hellgrüen schrägrechts teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.magenta": "Magenta schrägrechts teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.orange": "Orange schrägrächts teilt (umkehrt)",
  "block.minecraft.banner.diagonal_up_left.pink": "Rosa schrägrechts teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.purple": "Violett schrägrechts teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.red": "Rot schrägrechts teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.white": "Wiiss schrägrechts teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_left.yellow": "Gelb schrägrechts teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.black": "Schwarz schräglinks teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.blue": "Blau schräglinks teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.brown": "Brun schräglinks teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.cyan": "Türkis schräglinks teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.gray": "Grau schräglinks teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.green": "Grüen schräglinks teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Hellblau schräglinks teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Hellgrau schräglinks teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.lime": "Hellgrüen schräglinks teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.magenta": "Magenta schräglinks teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.orange": "Orange schräglinks teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.pink": "Rosa schräglinks teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.purple": "Violett schräglinks teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.red": "Rot schräglinks teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.white": "Wiiss schräglinks teilt (invertiert)",
  "block.minecraft.banner.diagonal_up_right.yellow": "Gelb schräglinks teilt (invertiert)",
  "block.minecraft.banner.flow.black": "Schwarze Fluss",
  "block.minecraft.banner.flow.blue": "Blaue Fluss",
  "block.minecraft.banner.flow.brown": "Brune Fluss",
  "block.minecraft.banner.flow.cyan": "Türkise Fluss",
  "block.minecraft.banner.flow.gray": "Graue Fluss",
  "block.minecraft.banner.flow.green": "Grüene Fluss",
  "block.minecraft.banner.flow.light_blue": "Hellblaue Fluss",
  "block.minecraft.banner.flow.light_gray": "Hellgraue Fluss",
  "block.minecraft.banner.flow.lime": "Hellgrüene Fluss",
  "block.minecraft.banner.flow.magenta": "Magenta Fluss",
  "block.minecraft.banner.flow.orange": "Orange Fluss",
  "block.minecraft.banner.flow.pink": "Rosa Fluss",
  "block.minecraft.banner.flow.purple": "Violette Fluss",
  "block.minecraft.banner.flow.red": "Rote Fluss",
  "block.minecraft.banner.flow.white": "Wiise Fluss",
  "block.minecraft.banner.flow.yellow": "Gelbe Fluss",
  "block.minecraft.banner.flower.black": "Schwarzi Blueme",
  "block.minecraft.banner.flower.blue": "Blaui Blueme",
  "block.minecraft.banner.flower.brown": "Bruni Blueme",
  "block.minecraft.banner.flower.cyan": "Türkisi Blueme",
  "block.minecraft.banner.flower.gray": "Graui Blueme",
  "block.minecraft.banner.flower.green": "Grüeni Blueme",
  "block.minecraft.banner.flower.light_blue": "Hellblaui Blueme",
  "block.minecraft.banner.flower.light_gray": "Hellgraui Blueme",
  "block.minecraft.banner.flower.lime": "Hellgrüeni Blueme",
  "block.minecraft.banner.flower.magenta": "Magenta Blueme",
  "block.minecraft.banner.flower.orange": "Orangi Blueme",
  "block.minecraft.banner.flower.pink": "Rosa Blueme",
  "block.minecraft.banner.flower.purple": "Violetti Blueme",
  "block.minecraft.banner.flower.red": "Roti Blueme",
  "block.minecraft.banner.flower.white": "Wiissi Blueme",
  "block.minecraft.banner.flower.yellow": "Gelbi Blueme",
  "block.minecraft.banner.globe.black": "Schwarze Globus",
  "block.minecraft.banner.globe.blue": "Blaue Globus",
  "block.minecraft.banner.globe.brown": "Brune Globus",
  "block.minecraft.banner.globe.cyan": "Türkise Globus",
  "block.minecraft.banner.globe.gray": "Graue Globus",
  "block.minecraft.banner.globe.green": "Grüene Globus",
  "block.minecraft.banner.globe.light_blue": "Hellblaue Globus",
  "block.minecraft.banner.globe.light_gray": "Hellgraue Globus",
  "block.minecraft.banner.globe.lime": "Hellgrüene Globus",
  "block.minecraft.banner.globe.magenta": "Magenta Globus",
  "block.minecraft.banner.globe.orange": "Orange Globus",
  "block.minecraft.banner.globe.pink": "Rosa Globus",
  "block.minecraft.banner.globe.purple": "Violette Globus",
  "block.minecraft.banner.globe.red": "Rote Globus",
  "block.minecraft.banner.globe.white": "Wiisse Globus",
  "block.minecraft.banner.globe.yellow": "Gelbe Globus",
  "block.minecraft.banner.gradient.black": "Schwarze Farbverlauf",
  "block.minecraft.banner.gradient.blue": "Blaue Farbverlauf",
  "block.minecraft.banner.gradient.brown": "Brune Farbverlauf",
  "block.minecraft.banner.gradient.cyan": "Türkise Farbverlauf",
  "block.minecraft.banner.gradient.gray": "Graue Farbverlauf",
  "block.minecraft.banner.gradient.green": "Grüene Farbverlauf",
  "block.minecraft.banner.gradient.light_blue": "Hellblaue Farbverlauf",
  "block.minecraft.banner.gradient.light_gray": "Hellgraue Farbverlauf",
  "block.minecraft.banner.gradient.lime": "Hellgrüene Farbverlauf",
  "block.minecraft.banner.gradient.magenta": "Magenta Farbverlauf",
  "block.minecraft.banner.gradient.orange": "Orange Farbverlauf",
  "block.minecraft.banner.gradient.pink": "Rosa Farbverlauf",
  "block.minecraft.banner.gradient.purple": "Violette Farbverlauf",
  "block.minecraft.banner.gradient.red": "Rote Farbverlauf",
  "block.minecraft.banner.gradient.white": "Wiisse Farbverlauf",
  "block.minecraft.banner.gradient.yellow": "Gelbe Farbverlauf",
  "block.minecraft.banner.gradient_up.black": "Schwarze Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.blue": "Blaue Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.brown": "Brune Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.cyan": "Türkise Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.gray": "Graue Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.green": "Grüene Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.light_blue": "Hellblaue Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.light_gray": "Hellgraue Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.lime": "Hellgrüene Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.magenta": "Magenta Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.orange": "Orange Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.pink": "Rosa Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.purple": "Violette Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.red": "Rote Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.white": "Wiisse Farbverlauf (invertiert)",
  "block.minecraft.banner.gradient_up.yellow": "Gelbe Farbverlauf (invertiert)",
  "block.minecraft.banner.guster.black": "Schwarze Windstosser",
  "block.minecraft.banner.guster.blue": "Blaue Windstosser",
  "block.minecraft.banner.guster.brown": "Brune Windstosser",
  "block.minecraft.banner.guster.cyan": "Türkise Windstosser",
  "block.minecraft.banner.guster.gray": "Graue Windstosser",
  "block.minecraft.banner.guster.green": "Grüene Windstosser",
  "block.minecraft.banner.guster.light_blue": "Hellblaue Windstosser",
  "block.minecraft.banner.guster.light_gray": "Hellgraue Windstosser",
  "block.minecraft.banner.guster.lime": "Hellgrüene Windstosser",
  "block.minecraft.banner.guster.magenta": "Magenta Windstosser",
  "block.minecraft.banner.guster.orange": "Orange Windstosser",
  "block.minecraft.banner.guster.pink": "Rosa Windstosser",
  "block.minecraft.banner.guster.purple": "Violette Windstosser",
  "block.minecraft.banner.guster.red": "Rote Windstosser",
  "block.minecraft.banner.guster.white": "Wiisse Windstosser",
  "block.minecraft.banner.guster.yellow": "Gelbe Windstosser",
  "block.minecraft.banner.half_horizontal.black": "Schwarz obe teilt",
  "block.minecraft.banner.half_horizontal.blue": "Blau obe teilt",
  "block.minecraft.banner.half_horizontal.brown": "Brun obe teilt",
  "block.minecraft.banner.half_horizontal.cyan": "Türkis obe teilt",
  "block.minecraft.banner.half_horizontal.gray": "Grau obe teilt",
  "block.minecraft.banner.half_horizontal.green": "Grüen obe teilt",
  "block.minecraft.banner.half_horizontal.light_blue": "Hellblau obe teilt",
  "block.minecraft.banner.half_horizontal.light_gray": "Hellgrau obe teilt",
  "block.minecraft.banner.half_horizontal.lime": "Hellgrüen obe teilt",
  "block.minecraft.banner.half_horizontal.magenta": "Magenta obe teilt",
  "block.minecraft.banner.half_horizontal.orange": "Orange obe teilt",
  "block.minecraft.banner.half_horizontal.pink": "Rosa obe teilt",
  "block.minecraft.banner.half_horizontal.purple": "Violett obe teilt",
  "block.minecraft.banner.half_horizontal.red": "Rot obe teilt",
  "block.minecraft.banner.half_horizontal.white": "Wiiss obe teilt",
  "block.minecraft.banner.half_horizontal.yellow": "Gelb obe teilt",
  "block.minecraft.banner.half_horizontal_bottom.black": "Schwarz une teilt",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Blau une teilt",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Brun une teilt",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Türkis une teilt",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Grau une teilt",
  "block.minecraft.banner.half_horizontal_bottom.green": "Grüen une teilt",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Hellblau une teilt",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Hellgrau une teilt",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Hellgrüen une teilt",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Magenta une teilt",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Orange une teilt",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Rosa une teilt",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Violett une teilt",
  "block.minecraft.banner.half_horizontal_bottom.red": "Rot une teilt",
  "block.minecraft.banner.half_horizontal_bottom.white": "Wiiss une teilt",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Gelb une teilt",
  "block.minecraft.banner.half_vertical.black": "Schwarz rechts gspalte",
  "block.minecraft.banner.half_vertical.blue": "Blau rechts gspalte",
  "block.minecraft.banner.half_vertical.brown": "Brun rechts gspalte",
  "block.minecraft.banner.half_vertical.cyan": "Türkis rechts gspalte",
  "block.minecraft.banner.half_vertical.gray": "Grau rechts gspalte",
  "block.minecraft.banner.half_vertical.green": "Grüen rechts gspalte",
  "block.minecraft.banner.half_vertical.light_blue": "Hellblau rechts gspalte",
  "block.minecraft.banner.half_vertical.light_gray": "Hellgrau rechts gspalte",
  "block.minecraft.banner.half_vertical.lime": "Hellgrüen rechts gspalte",
  "block.minecraft.banner.half_vertical.magenta": "Magenta rechts gspalte",
  "block.minecraft.banner.half_vertical.orange": "Orange rechts gspalte",
  "block.minecraft.banner.half_vertical.pink": "Rosa rechts gspalte",
  "block.minecraft.banner.half_vertical.purple": "Violett rechts gspalte",
  "block.minecraft.banner.half_vertical.red": "Rot rechts gspalte",
  "block.minecraft.banner.half_vertical.white": "Wiiss rechts gspalte",
  "block.minecraft.banner.half_vertical.yellow": "Gelb rechts gspalte",
  "block.minecraft.banner.half_vertical_right.black": "Schwarz links gspalte",
  "block.minecraft.banner.half_vertical_right.blue": "Blau links gspalte",
  "block.minecraft.banner.half_vertical_right.brown": "Brun links gspalte",
  "block.minecraft.banner.half_vertical_right.cyan": "Türkis links gspalte",
  "block.minecraft.banner.half_vertical_right.gray": "Grau links gspalte",
  "block.minecraft.banner.half_vertical_right.green": "Grüen links gspalte",
  "block.minecraft.banner.half_vertical_right.light_blue": "Hellblau links gspalte",
  "block.minecraft.banner.half_vertical_right.light_gray": "Hellgrau links gspalte",
  "block.minecraft.banner.half_vertical_right.lime": "Hellgrüen links gspalte",
  "block.minecraft.banner.half_vertical_right.magenta": "Magenta links gspalte",
  "block.minecraft.banner.half_vertical_right.orange": "Orange links gspalte",
  "block.minecraft.banner.half_vertical_right.pink": "Rosa links gspalte",
  "block.minecraft.banner.half_vertical_right.purple": "Violett links gspalte",
  "block.minecraft.banner.half_vertical_right.red": "Rot links gspalte",
  "block.minecraft.banner.half_vertical_right.white": "Wiiss links gspalte",
  "block.minecraft.banner.half_vertical_right.yellow": "Gelb links gspalte",
  "block.minecraft.banner.mojang.black": "Schwarzes Mojang-Logo",
  "block.minecraft.banner.mojang.blue": "Blaus Mojang-Logo",
  "block.minecraft.banner.mojang.brown": "Bruns Mojang-Logo",
  "block.minecraft.banner.mojang.cyan": "Türkises Mojang-Logo",
  "block.minecraft.banner.mojang.gray": "Graus Mojang-Logo",
  "block.minecraft.banner.mojang.green": "Grüens Mojang-Logo",
  "block.minecraft.banner.mojang.light_blue": "Hellblaus Mojang-Logo",
  "block.minecraft.banner.mojang.light_gray": "Hellgraus Mojang-Logo",
  "block.minecraft.banner.mojang.lime": "Hellgrüens Mojang-Logo",
  "block.minecraft.banner.mojang.magenta": "Magenta Mojang-Logo",
  "block.minecraft.banner.mojang.orange": "Oranges Mojang-Logo",
  "block.minecraft.banner.mojang.pink": "Rosa Mojang-Logo",
  "block.minecraft.banner.mojang.purple": "Violetts Mojang-Logo",
  "block.minecraft.banner.mojang.red": "Rots Mojang-Logo",
  "block.minecraft.banner.mojang.white": "Wiisses Mojang-Logo",
  "block.minecraft.banner.mojang.yellow": "Gelbes Mojang-Logo",
  "block.minecraft.banner.piglin.black": "Schwarzi Schnauze",
  "block.minecraft.banner.piglin.blue": "Blaui Schnauze",
  "block.minecraft.banner.piglin.brown": "Bruni Schnauze",
  "block.minecraft.banner.piglin.cyan": "Türkisi Schnauze",
  "block.minecraft.banner.piglin.gray": "Graui Schnauze",
  "block.minecraft.banner.piglin.green": "Grüeni Schnauze",
  "block.minecraft.banner.piglin.light_blue": "Hellblaui Schnauze",
  "block.minecraft.banner.piglin.light_gray": "Hellgraui Schnauze",
  "block.minecraft.banner.piglin.lime": "Hellgrüeni Schnauze",
  "block.minecraft.banner.piglin.magenta": "Magenta Schnauze",
  "block.minecraft.banner.piglin.orange": "Orangi Schnauze",
  "block.minecraft.banner.piglin.pink": "Rosa Schnauze",
  "block.minecraft.banner.piglin.purple": "Violetti Schnauze",
  "block.minecraft.banner.piglin.red": "Roti Schnauze",
  "block.minecraft.banner.piglin.white": "Wiissi Schnauze",
  "block.minecraft.banner.piglin.yellow": "Gelbi Schnauze",
  "block.minecraft.banner.rhombus.black": "Schwarzi Raute",
  "block.minecraft.banner.rhombus.blue": "Blaui Raute",
  "block.minecraft.banner.rhombus.brown": "Bruni Raute",
  "block.minecraft.banner.rhombus.cyan": "Türkisi Raute",
  "block.minecraft.banner.rhombus.gray": "Graui Raute",
  "block.minecraft.banner.rhombus.green": "Grüeni Raute",
  "block.minecraft.banner.rhombus.light_blue": "Hellblaui Raute",
  "block.minecraft.banner.rhombus.light_gray": "Hellgraui Raute",
  "block.minecraft.banner.rhombus.lime": "Hellgrüeni Raute",
  "block.minecraft.banner.rhombus.magenta": "Magenta Raute",
  "block.minecraft.banner.rhombus.orange": "Orangi Raute",
  "block.minecraft.banner.rhombus.pink": "Rosa Raute",
  "block.minecraft.banner.rhombus.purple": "Violetti Raute",
  "block.minecraft.banner.rhombus.red": "Roti Raute",
  "block.minecraft.banner.rhombus.white": "Wiissi Raute",
  "block.minecraft.banner.rhombus.yellow": "Gelbi Raute",
  "block.minecraft.banner.skull.black": "Schwarze Schädel",
  "block.minecraft.banner.skull.blue": "Blaue Schädel",
  "block.minecraft.banner.skull.brown": "Brune Schädel",
  "block.minecraft.banner.skull.cyan": "Türkise Schädel",
  "block.minecraft.banner.skull.gray": "Graue Schädel",
  "block.minecraft.banner.skull.green": "Grüene Schädel",
  "block.minecraft.banner.skull.light_blue": "Hellblaue Schädel",
  "block.minecraft.banner.skull.light_gray": "Hellgraue Schädel",
  "block.minecraft.banner.skull.lime": "Hellgrüene Schädel",
  "block.minecraft.banner.skull.magenta": "Magenta Schädel",
  "block.minecraft.banner.skull.orange": "Orange Schädel",
  "block.minecraft.banner.skull.pink": "Rosa Schädel",
  "block.minecraft.banner.skull.purple": "Violette Schädel",
  "block.minecraft.banner.skull.red": "Rote Schädel",
  "block.minecraft.banner.skull.white": "Wiisse Schädel",
  "block.minecraft.banner.skull.yellow": "Gelbe Schädel",
  "block.minecraft.banner.small_stripes.black": "Vier schwarzi Pfähl",
  "block.minecraft.banner.small_stripes.blue": "Vier blaui Pfähl",
  "block.minecraft.banner.small_stripes.brown": "Vier bruni Pfähl",
  "block.minecraft.banner.small_stripes.cyan": "Vier türkisi Pfähl",
  "block.minecraft.banner.small_stripes.gray": "Vier graui Pfähl",
  "block.minecraft.banner.small_stripes.green": "Vier grüeni Pfähl",
  "block.minecraft.banner.small_stripes.light_blue": "Vier hellblaui Pfähl",
  "block.minecraft.banner.small_stripes.light_gray": "Vier hellgraui Pfähl",
  "block.minecraft.banner.small_stripes.lime": "Vier hellgrüeni Pfähl",
  "block.minecraft.banner.small_stripes.magenta": "Vier magenta Pfähl",
  "block.minecraft.banner.small_stripes.orange": "Vier orangi Pfähl",
  "block.minecraft.banner.small_stripes.pink": "Vier rosa Pfähl",
  "block.minecraft.banner.small_stripes.purple": "Vier violetti Pfähl",
  "block.minecraft.banner.small_stripes.red": "Vier roti Pfähl",
  "block.minecraft.banner.small_stripes.white": "Vier wiissi Pfähl",
  "block.minecraft.banner.small_stripes.yellow": "Vier gelbi Pfähl",
  "block.minecraft.banner.square_bottom_left.black": "Schwarzes rechts Untereck",
  "block.minecraft.banner.square_bottom_left.blue": "Blaus rechts Untereck",
  "block.minecraft.banner.square_bottom_left.brown": "Bruns rechts Untereck",
  "block.minecraft.banner.square_bottom_left.cyan": "Türkises rechts Untereck",
  "block.minecraft.banner.square_bottom_left.gray": "Graus rechts Untereck",
  "block.minecraft.banner.square_bottom_left.green": "Grüens rechts Untereck",
  "block.minecraft.banner.square_bottom_left.light_blue": "Hellblaus rechts Untereck",
  "block.minecraft.banner.square_bottom_left.light_gray": "Hellgraus rechts Untereck",
  "block.minecraft.banner.square_bottom_left.lime": "Hellgrüens rechts Untereck",
  "block.minecraft.banner.square_bottom_left.magenta": "Magenta rechts Untereck",
  "block.minecraft.banner.square_bottom_left.orange": "Oranges rechts Untereck",
  "block.minecraft.banner.square_bottom_left.pink": "Rosa rechts Untereck",
  "block.minecraft.banner.square_bottom_left.purple": "Violetts rechts Untereck",
  "block.minecraft.banner.square_bottom_left.red": "Rots rechts Untereck",
  "block.minecraft.banner.square_bottom_left.white": "Wiisses rechts Untereck",
  "block.minecraft.banner.square_bottom_left.yellow": "Gelbes rechts Untereck",
  "block.minecraft.banner.square_bottom_right.black": "Schwarzes links Untereck",
  "block.minecraft.banner.square_bottom_right.blue": "Blaus links Untereck",
  "block.minecraft.banner.square_bottom_right.brown": "Bruns links Untereck",
  "block.minecraft.banner.square_bottom_right.cyan": "Türkises links Untereck",
  "block.minecraft.banner.square_bottom_right.gray": "Graus links Untereck",
  "block.minecraft.banner.square_bottom_right.green": "Grüens links Untereck",
  "block.minecraft.banner.square_bottom_right.light_blue": "Hellblaus links Untereck",
  "block.minecraft.banner.square_bottom_right.light_gray": "Hellgraus links Untereck",
  "block.minecraft.banner.square_bottom_right.lime": "Hellgrüens links Untereck",
  "block.minecraft.banner.square_bottom_right.magenta": "Magenta links Untereck",
  "block.minecraft.banner.square_bottom_right.orange": "Oranges links Untereck",
  "block.minecraft.banner.square_bottom_right.pink": "Rosa links Untereck",
  "block.minecraft.banner.square_bottom_right.purple": "Violetts links Untereck",
  "block.minecraft.banner.square_bottom_right.red": "Rots links Untereck",
  "block.minecraft.banner.square_bottom_right.white": "Wiisses links Untereck",
  "block.minecraft.banner.square_bottom_right.yellow": "Gelbes links Untereck",
  "block.minecraft.banner.square_top_left.black": "Schwarzes rechts Obereck",
  "block.minecraft.banner.square_top_left.blue": "Blaus rechts Obereck",
  "block.minecraft.banner.square_top_left.brown": "Bruns rechts Obereck",
  "block.minecraft.banner.square_top_left.cyan": "Türkises rechts Obereck",
  "block.minecraft.banner.square_top_left.gray": "Graus rechts Obereck",
  "block.minecraft.banner.square_top_left.green": "Grüens rechts Obereck",
  "block.minecraft.banner.square_top_left.light_blue": "Hellblaus rechts Obereck",
  "block.minecraft.banner.square_top_left.light_gray": "Hellgraus rechts Obereck",
  "block.minecraft.banner.square_top_left.lime": "Hellgrüens rechts Obereck",
  "block.minecraft.banner.square_top_left.magenta": "Magenta rechts Obereck",
  "block.minecraft.banner.square_top_left.orange": "Oranges rechts Obereck",
  "block.minecraft.banner.square_top_left.pink": "Rosa rechts Obereck",
  "block.minecraft.banner.square_top_left.purple": "Violetts rechts Obereck",
  "block.minecraft.banner.square_top_left.red": "Rots rechts Obereck",
  "block.minecraft.banner.square_top_left.white": "Wiisses rechts Obereck",
  "block.minecraft.banner.square_top_left.yellow": "Gelbes rechts Obereck",
  "block.minecraft.banner.square_top_right.black": "Schwarzes links Obereck",
  "block.minecraft.banner.square_top_right.blue": "Blaus links Obereck",
  "block.minecraft.banner.square_top_right.brown": "Bruns links Obereck",
  "block.minecraft.banner.square_top_right.cyan": "Türkises links Obereck",
  "block.minecraft.banner.square_top_right.gray": "Graus links Obereck",
  "block.minecraft.banner.square_top_right.green": "Grüens links Obereck",
  "block.minecraft.banner.square_top_right.light_blue": "Hellblaus links Obereck",
  "block.minecraft.banner.square_top_right.light_gray": "Hellgraus links Obereck",
  "block.minecraft.banner.square_top_right.lime": "Hellgrüens links Obereck",
  "block.minecraft.banner.square_top_right.magenta": "Magenta links Obereck",
  "block.minecraft.banner.square_top_right.orange": "Oranges links Obereck",
  "block.minecraft.banner.square_top_right.pink": "Rosa links Obereck",
  "block.minecraft.banner.square_top_right.purple": "Violetts links Obereck",
  "block.minecraft.banner.square_top_right.red": "Rots links Obereck",
  "block.minecraft.banner.square_top_right.white": "Wiisses links Obereck",
  "block.minecraft.banner.square_top_right.yellow": "Gelbes links Obereck",
  "block.minecraft.banner.straight_cross.black": "Schwarzes Chrüüz",
  "block.minecraft.banner.straight_cross.blue": "Blaus Chrüüz",
  "block.minecraft.banner.straight_cross.brown": "Bruns Chrüüz",
  "block.minecraft.banner.straight_cross.cyan": "Türkises Chrüüz",
  "block.minecraft.banner.straight_cross.gray": "Graus Chrüüz",
  "block.minecraft.banner.straight_cross.green": "Grüens Chrüüz",
  "block.minecraft.banner.straight_cross.light_blue": "Hellblaus Chrüüz",
  "block.minecraft.banner.straight_cross.light_gray": "Hellgraus Chrüüz",
  "block.minecraft.banner.straight_cross.lime": "Hellgrüens Chrüüz",
  "block.minecraft.banner.straight_cross.magenta": "Magenta Chrüüz",
  "block.minecraft.banner.straight_cross.orange": "Oranges Chrüüz",
  "block.minecraft.banner.straight_cross.pink": "Rosa Chrüüz",
  "block.minecraft.banner.straight_cross.purple": "Violetts Chrüüz",
  "block.minecraft.banner.straight_cross.red": "Rots Chrüüz",
  "block.minecraft.banner.straight_cross.white": "Wiisses Chrüüz",
  "block.minecraft.banner.straight_cross.yellow": "Gelbes Chrüüz",
  "block.minecraft.banner.stripe_bottom.black": "Schwarze Bannerfuess",
  "block.minecraft.banner.stripe_bottom.blue": "Blaue Bannerfuess",
  "block.minecraft.banner.stripe_bottom.brown": "Brune Bannerfuess",
  "block.minecraft.banner.stripe_bottom.cyan": "Türkise Bannerfuess",
  "block.minecraft.banner.stripe_bottom.gray": "Graue Bannerfuess",
  "block.minecraft.banner.stripe_bottom.green": "Grüene Bannerfuess",
  "block.minecraft.banner.stripe_bottom.light_blue": "Hellblaue Bannerfuess",
  "block.minecraft.banner.stripe_bottom.light_gray": "Hellbraue Bannerfuess",
  "block.minecraft.banner.stripe_bottom.lime": "Hellgrüene Bannerfuess",
  "block.minecraft.banner.stripe_bottom.magenta": "Magenta Bannerfuess",
  "block.minecraft.banner.stripe_bottom.orange": "Orange Bannerfuess",
  "block.minecraft.banner.stripe_bottom.pink": "Rosa Bannerfuess",
  "block.minecraft.banner.stripe_bottom.purple": "Violette Bannerfuess",
  "block.minecraft.banner.stripe_bottom.red": "Rote Bannerfuess",
  "block.minecraft.banner.stripe_bottom.white": "Wiisse Bannerfuess",
  "block.minecraft.banner.stripe_bottom.yellow": "Gelbe Bannerfuess",
  "block.minecraft.banner.stripe_center.black": "Schwarze Pfahl",
  "block.minecraft.banner.stripe_center.blue": "Blaue Pfahl",
  "block.minecraft.banner.stripe_center.brown": "Brune Pfahl",
  "block.minecraft.banner.stripe_center.cyan": "Türkise Pfahl",
  "block.minecraft.banner.stripe_center.gray": "Graue Pfahl",
  "block.minecraft.banner.stripe_center.green": "Grüene Pfahl",
  "block.minecraft.banner.stripe_center.light_blue": "Hellblaue Pfahl",
  "block.minecraft.banner.stripe_center.light_gray": "Hellgraue Pfahl",
  "block.minecraft.banner.stripe_center.lime": "Hellgrüene Pfahl",
  "block.minecraft.banner.stripe_center.magenta": "Magenta Pfahl",
  "block.minecraft.banner.stripe_center.orange": "Orange Pfahl",
  "block.minecraft.banner.stripe_center.pink": "Rosa Pfahl",
  "block.minecraft.banner.stripe_center.purple": "Violette Pfahl",
  "block.minecraft.banner.stripe_center.red": "Rote Pfahl",
  "block.minecraft.banner.stripe_center.white": "Wiisse Pfahl",
  "block.minecraft.banner.stripe_center.yellow": "Gelbe Pfahl",
  "block.minecraft.banner.stripe_downleft.black": "Schwarze Schräglinksbalke",
  "block.minecraft.banner.stripe_downleft.blue": "Blaue Schräglinksbalke",
  "block.minecraft.banner.stripe_downleft.brown": "Brune Schräglinksbalke",
  "block.minecraft.banner.stripe_downleft.cyan": "Türkise Schräglinksbalke",
  "block.minecraft.banner.stripe_downleft.gray": "Graue Schräglinksbalke",
  "block.minecraft.banner.stripe_downleft.green": "Grüene Schräglinksbalke",
  "block.minecraft.banner.stripe_downleft.light_blue": "Hellblaue Schräglinksbalke",
  "block.minecraft.banner.stripe_downleft.light_gray": "Hellgraue Schräglinksbalke",
  "block.minecraft.banner.stripe_downleft.lime": "Hellgrüene Schräglinksbalke",
  "block.minecraft.banner.stripe_downleft.magenta": "Magenta Schräglinksbalke",
  "block.minecraft.banner.stripe_downleft.orange": "Orange Schräglinksbalke",
  "block.minecraft.banner.stripe_downleft.pink": "Rosa Schräglinksbalke",
  "block.minecraft.banner.stripe_downleft.purple": "Violette Schräglinksbalke",
  "block.minecraft.banner.stripe_downleft.red": "Rote Schräglinksbalke",
  "block.minecraft.banner.stripe_downleft.white": "Wiisse Schräglinksbalke",
  "block.minecraft.banner.stripe_downleft.yellow": "Gelbe Schräglinksbalke",
  "block.minecraft.banner.stripe_downright.black": "Schwarze Schrägbalke",
  "block.minecraft.banner.stripe_downright.blue": "Blaue Schrägbalke",
  "block.minecraft.banner.stripe_downright.brown": "Brune Schrägbalke",
  "block.minecraft.banner.stripe_downright.cyan": "Türkise Schrägbalke",
  "block.minecraft.banner.stripe_downright.gray": "Graue Schrägbalke",
  "block.minecraft.banner.stripe_downright.green": "Grüene Schrägbalke",
  "block.minecraft.banner.stripe_downright.light_blue": "Hellblaue Schrägbalke",
  "block.minecraft.banner.stripe_downright.light_gray": "Hellgraue Schrägbalke",
  "block.minecraft.banner.stripe_downright.lime": "Hellgrüene Schrägbalke",
  "block.minecraft.banner.stripe_downright.magenta": "Magenta Schrägbalke",
  "block.minecraft.banner.stripe_downright.orange": "Orange Schrägbalke",
  "block.minecraft.banner.stripe_downright.pink": "Rosa Schrägbalke",
  "block.minecraft.banner.stripe_downright.purple": "Violette Schrägbalke",
  "block.minecraft.banner.stripe_downright.red": "Rote Schrägbalke",
  "block.minecraft.banner.stripe_downright.white": "Wiisse Schrägbalke",
  "block.minecraft.banner.stripe_downright.yellow": "Gelbe Schrägbalke",
  "block.minecraft.banner.stripe_left.black": "Schwarzi rechti Flanke",
  "block.minecraft.banner.stripe_left.blue": "Blaui rechti Flanke",
  "block.minecraft.banner.stripe_left.brown": "Bruni rechti Flanke",
  "block.minecraft.banner.stripe_left.cyan": "Türkisi rechti Flanke",
  "block.minecraft.banner.stripe_left.gray": "Graui rechti Flanke",
  "block.minecraft.banner.stripe_left.green": "Grüeni rechti Flanke",
  "block.minecraft.banner.stripe_left.light_blue": "Hellblaui rechti Flanke",
  "block.minecraft.banner.stripe_left.light_gray": "Hellgraui rechti Flanke",
  "block.minecraft.banner.stripe_left.lime": "Hellgrüeni rechti Flanke",
  "block.minecraft.banner.stripe_left.magenta": "Magenta rechti Flanke",
  "block.minecraft.banner.stripe_left.orange": "Orangi rechti Flanke",
  "block.minecraft.banner.stripe_left.pink": "Rosa rechti Flanke",
  "block.minecraft.banner.stripe_left.purple": "Violetti rechti Flanke",
  "block.minecraft.banner.stripe_left.red": "Roti rechti Flanke",
  "block.minecraft.banner.stripe_left.white": "Wiissi rechti Flanke",
  "block.minecraft.banner.stripe_left.yellow": "Gelbi rechti Flanke",
  "block.minecraft.banner.stripe_middle.black": "Schwarze Balke",
  "block.minecraft.banner.stripe_middle.blue": "Blaue Balke",
  "block.minecraft.banner.stripe_middle.brown": "Brune Balke",
  "block.minecraft.banner.stripe_middle.cyan": "Türkise Balke",
  "block.minecraft.banner.stripe_middle.gray": "Graue Balke",
  "block.minecraft.banner.stripe_middle.green": "Grüene Balke",
  "block.minecraft.banner.stripe_middle.light_blue": "Hellblaue Balke",
  "block.minecraft.banner.stripe_middle.light_gray": "Hellgraue Balke",
  "block.minecraft.banner.stripe_middle.lime": "Hellgrüene Balke",
  "block.minecraft.banner.stripe_middle.magenta": "Magenta Balke",
  "block.minecraft.banner.stripe_middle.orange": "Orange Balke",
  "block.minecraft.banner.stripe_middle.pink": "Rosa Balke",
  "block.minecraft.banner.stripe_middle.purple": "Violette Balke",
  "block.minecraft.banner.stripe_middle.red": "Rote Balke",
  "block.minecraft.banner.stripe_middle.white": "Wiisse Balke",
  "block.minecraft.banner.stripe_middle.yellow": "Gelbe Balke",
  "block.minecraft.banner.stripe_right.black": "Schwarzi linki Flanke",
  "block.minecraft.banner.stripe_right.blue": "Blaui linki Flanke",
  "block.minecraft.banner.stripe_right.brown": "Bruni linki Flanke",
  "block.minecraft.banner.stripe_right.cyan": "Türkisi linki Flanke",
  "block.minecraft.banner.stripe_right.gray": "Graui linki Flanke",
  "block.minecraft.banner.stripe_right.green": "Grüeni linki Flanke",
  "block.minecraft.banner.stripe_right.light_blue": "Hellblaui linki Flanke",
  "block.minecraft.banner.stripe_right.light_gray": "Hellgraui linki Flanke",
  "block.minecraft.banner.stripe_right.lime": "Hellgrüeni linki Flanke",
  "block.minecraft.banner.stripe_right.magenta": "Magenta linki Flanke",
  "block.minecraft.banner.stripe_right.orange": "Orangi linki Flanke",
  "block.minecraft.banner.stripe_right.pink": "Rosa linki Flanke",
  "block.minecraft.banner.stripe_right.purple": "Violetti linki Flanke",
  "block.minecraft.banner.stripe_right.red": "Roti linki Flanke",
  "block.minecraft.banner.stripe_right.white": "Wiissi linki Flanke",
  "block.minecraft.banner.stripe_right.yellow": "Gelbi linki Flanke",
  "block.minecraft.banner.stripe_top.black": "Schwarzes Bannerhaupt",
  "block.minecraft.banner.stripe_top.blue": "Blaus Bannerhaupt",
  "block.minecraft.banner.stripe_top.brown": "Bruns Bannerhaupt",
  "block.minecraft.banner.stripe_top.cyan": "Türkises Bannerhaupt",
  "block.minecraft.banner.stripe_top.gray": "Graus Bannerhaupt",
  "block.minecraft.banner.stripe_top.green": "Grüens Bannerhaupt",
  "block.minecraft.banner.stripe_top.light_blue": "Hellblaus Bannerhaupt",
  "block.minecraft.banner.stripe_top.light_gray": "Hellgraus Bannerhaupt",
  "block.minecraft.banner.stripe_top.lime": "Hellgrüens Bannerhaupt",
  "block.minecraft.banner.stripe_top.magenta": "Magenta Bannerhaupt",
  "block.minecraft.banner.stripe_top.orange": "Oranges Bannerhaupt",
  "block.minecraft.banner.stripe_top.pink": "Rosa Bannerhaupt",
  "block.minecraft.banner.stripe_top.purple": "Violetts Bannerhaupt",
  "block.minecraft.banner.stripe_top.red": "Rots Bannerhaupt",
  "block.minecraft.banner.stripe_top.white": "Wiisses Bannerhaupt",
  "block.minecraft.banner.stripe_top.yellow": "Gelbes Bannerhaupt",
  "block.minecraft.banner.triangle_bottom.black": "Schwarzi halbi Spitze",
  "block.minecraft.banner.triangle_bottom.blue": "Blaui halbi Spitze",
  "block.minecraft.banner.triangle_bottom.brown": "Bruni halbi Spitze",
  "block.minecraft.banner.triangle_bottom.cyan": "Türkisi halbi Spitze",
  "block.minecraft.banner.triangle_bottom.gray": "Graui halbi Spitze",
  "block.minecraft.banner.triangle_bottom.green": "Grüeni halbi Spitze",
  "block.minecraft.banner.triangle_bottom.light_blue": "Hellblaui halbi Spitze",
  "block.minecraft.banner.triangle_bottom.light_gray": "Hellgraui halbi Spitze",
  "block.minecraft.banner.triangle_bottom.lime": "Hellgrüeni halbi Spitze",
  "block.minecraft.banner.triangle_bottom.magenta": "Magenta halbi Spitze",
  "block.minecraft.banner.triangle_bottom.orange": "Orangi halbi Spitze",
  "block.minecraft.banner.triangle_bottom.pink": "Rosa halbi Spitze",
  "block.minecraft.banner.triangle_bottom.purple": "Violetti halbi Spitze",
  "block.minecraft.banner.triangle_bottom.red": "Roti halbi Spitze",
  "block.minecraft.banner.triangle_bottom.white": "Wiissi halbi Spitze",
  "block.minecraft.banner.triangle_bottom.yellow": "Gelbi halbi Spitze",
  "block.minecraft.banner.triangle_top.black": "Schwarzi gstürzti halbi Spitze",
  "block.minecraft.banner.triangle_top.blue": "Blaui gstürzti halbi Spitze",
  "block.minecraft.banner.triangle_top.brown": "Bruni gstürzti halbi Spitze",
  "block.minecraft.banner.triangle_top.cyan": "Türkisi gstürzti halbi Spitze",
  "block.minecraft.banner.triangle_top.gray": "Graui gstürzti halbi Spitze",
  "block.minecraft.banner.triangle_top.green": "Grüeni gstürzti halbi Spitze",
  "block.minecraft.banner.triangle_top.light_blue": "Hellblaui gstürzti halbi Spitze",
  "block.minecraft.banner.triangle_top.light_gray": "Hellgraui gstürzti halbi Spitze",
  "block.minecraft.banner.triangle_top.lime": "Hellgrüeni gstürzti halbi Spitze",
  "block.minecraft.banner.triangle_top.magenta": "Magenta gstürzti halbi Spitze",
  "block.minecraft.banner.triangle_top.orange": "Orangi gstürzti halbi Spitze",
  "block.minecraft.banner.triangle_top.pink": "Rosa gstürzti halbi Spitze",
  "block.minecraft.banner.triangle_top.purple": "Violetti gstürzti halbi Spitze",
  "block.minecraft.banner.triangle_top.red": "Roti gstürzti halbi Spitze",
  "block.minecraft.banner.triangle_top.white": "Wiissi gstürzti halbi Spitze",
  "block.minecraft.banner.triangle_top.yellow": "Gelbi gstürzti halbi Spitze",
  "block.minecraft.banner.triangles_bottom.black": "Schwarze gspickelte Bannerfuess",
  "block.minecraft.banner.triangles_bottom.blue": "Blaue gspickelte Bannerfuess",
  "block.minecraft.banner.triangles_bottom.brown": "Brune gspickelte Bannerfuess",
  "block.minecraft.banner.triangles_bottom.cyan": "Türkise gspickelte Bannerfuess",
  "block.minecraft.banner.triangles_bottom.gray": "Graue gspickelte Bannerfuess",
  "block.minecraft.banner.triangles_bottom.green": "Grüene gspickelte Bannerfuess",
  "block.minecraft.banner.triangles_bottom.light_blue": "Hellblaue gspickelte Bannerfuess",
  "block.minecraft.banner.triangles_bottom.light_gray": "Hellgraue gspickelte Bannerfuess",
  "block.minecraft.banner.triangles_bottom.lime": "Hellgrüene gspickelte Bannerfuess",
  "block.minecraft.banner.triangles_bottom.magenta": "Magenta gspickelte Bannerfuess",
  "block.minecraft.banner.triangles_bottom.orange": "Orange gspickelte Bannerfuess",
  "block.minecraft.banner.triangles_bottom.pink": "Rosa gspickelte Bannerfuess",
  "block.minecraft.banner.triangles_bottom.purple": "Violette gspickelte Bannerfuess",
  "block.minecraft.banner.triangles_bottom.red": "Rote gspickelte Bannerfuess",
  "block.minecraft.banner.triangles_bottom.white": "Wiisse gspickelte Bannerfuess",
  "block.minecraft.banner.triangles_bottom.yellow": "Gelbe gspickelte Bannerfuess",
  "block.minecraft.banner.triangles_top.black": "Schwarzes gspickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.blue": "Blaus gspickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.brown": "Bruns gspickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.cyan": "Türkises gspickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.gray": "Graus gspickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.green": "Grüens gspickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.light_blue": "Hellblaus gspickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.light_gray": "Hellgraus gspickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.lime": "Hellgrüens gspickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.magenta": "Magenta gspickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.orange": "Oranges gspickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.pink": "Rosa gspickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.purple": "Violetts gspickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.red": "Rots gspickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.white": "Wiisses gspickeltes Bannerhaupt",
  "block.minecraft.banner.triangles_top.yellow": "Gelbes gspickeltes Bannerhaupt",
  "block.minecraft.barrel": "Fass",
  "block.minecraft.barrier": "Barriere",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Lüchtfüür",
  "block.minecraft.beacon.primary": "Primäri Chraft",
  "block.minecraft.beacon.secondary": "Sekundäri Chraft",
  "block.minecraft.bed.no_sleep": "Du chasch nur ide Nacht oder während enem Gwitter schlafe",
  "block.minecraft.bed.not_safe": "Du chasch jetzt nöd schlafe, es sind Monster ide Nächi",
  "block.minecraft.bed.obstructed": "Das Bett isch blockiert",
  "block.minecraft.bed.occupied": "Das Bett isch beleit",
  "block.minecraft.bed.too_far_away": "Du chasch jetzt nöd schlafe, s'Bett isch z'wiit weg",
  "block.minecraft.bedrock": "Grundgstei",
  "block.minecraft.bee_nest": "Bienenest",
  "block.minecraft.beehive": "Bienestock",
  "block.minecraft.beetroots": "Rande",
  "block.minecraft.bell": "Glocke",
  "block.minecraft.big_dripleaf": "Grosses Tropfblatt",
  "block.minecraft.big_dripleaf_stem": "Grosse Tropfblattstiel",
  "block.minecraft.birch_button": "Birkeholzchnopf",
  "block.minecraft.birch_door": "Birkeholztür",
  "block.minecraft.birch_fence": "Birkeholzhaag",
  "block.minecraft.birch_fence_gate": "Birkeholzhaagtor",
  "block.minecraft.birch_hanging_sign": "Birkeholzhängeschild",
  "block.minecraft.birch_leaves": "Birkelaub",
  "block.minecraft.birch_log": "Birkestamm",
  "block.minecraft.birch_planks": "Birkeholzbretter",
  "block.minecraft.birch_pressure_plate": "Birkeholzdruckplatte",
  "block.minecraft.birch_sapling": "Birkesetzling",
  "block.minecraft.birch_shelf": "Birkeholzregal",
  "block.minecraft.birch_sign": "Birkeholzschild",
  "block.minecraft.birch_slab": "Birkeholzstufe",
  "block.minecraft.birch_stairs": "Birkeholzstäge",
  "block.minecraft.birch_trapdoor": "Birkeholzfalltür",
  "block.minecraft.birch_wall_hanging_sign": "Birkeholzwandhängeschild",
  "block.minecraft.birch_wall_sign": "Birkeholzwandschild",
  "block.minecraft.birch_wood": "Birkeholz",
  "block.minecraft.black_banner": "Schwarzes Banner",
  "block.minecraft.black_bed": "Schwarzes Bett",
  "block.minecraft.black_candle": "Schwarzi Cherze",
  "block.minecraft.black_candle_cake": "Chueche mit schwarzer Cherze",
  "block.minecraft.black_carpet": "Schwarze Teppich",
  "block.minecraft.black_concrete": "Schwarze Beton",
  "block.minecraft.black_concrete_powder": "Schwarze Trochebeton",
  "block.minecraft.black_glazed_terracotta": "Schwarz glasierte Keramik",
  "block.minecraft.black_shulker_box": "Schwarzi Shulker-Chiste",
  "block.minecraft.black_stained_glass": "Schwarzes Glas",
  "block.minecraft.black_stained_glass_pane": "Schwarzi Glasschiibe",
  "block.minecraft.black_terracotta": "Schwarze Keramik",
  "block.minecraft.black_wool": "Schwarzi Wulle",
  "block.minecraft.blackstone": "Schwarzstei",
  "block.minecraft.blackstone_slab": "Schwarzsteistufe",
  "block.minecraft.blackstone_stairs": "Schwarzsteistäge",
  "block.minecraft.blackstone_wall": "Schwarzsteimur",
  "block.minecraft.blast_furnace": "Schmelzofe",
  "block.minecraft.blue_banner": "Blaus Banner",
  "block.minecraft.blue_bed": "Blaus Bett",
  "block.minecraft.blue_candle": "Blaui Cherze",
  "block.minecraft.blue_candle_cake": "Chueche mit blauer Cherze",
  "block.minecraft.blue_carpet": "Blaue Teppich",
  "block.minecraft.blue_concrete": "Blaue Beton",
  "block.minecraft.blue_concrete_powder": "Blaue Trochebeton",
  "block.minecraft.blue_glazed_terracotta": "Blaue glasierte Keramik",
  "block.minecraft.blue_ice": "Blauiis",
  "block.minecraft.blue_orchid": "Blaui Orchidee",
  "block.minecraft.blue_shulker_box": "Blaui Shulker-Chiste",
  "block.minecraft.blue_stained_glass": "Blaus Glas",
  "block.minecraft.blue_stained_glass_pane": "Blaui Glasschiibe",
  "block.minecraft.blue_terracotta": "Blaue Keramik",
  "block.minecraft.blue_wool": "Blaui Wulle",
  "block.minecraft.bone_block": "Chnocheblock",
  "block.minecraft.bookshelf": "Büecherregal",
  "block.minecraft.brain_coral": "Hirnkoralle",
  "block.minecraft.brain_coral_block": "Hirnkoralleblock",
  "block.minecraft.brain_coral_fan": "Hirnkorallefächer",
  "block.minecraft.brain_coral_wall_fan": "Hirnkorallewandfächer",
  "block.minecraft.brewing_stand": "Braustand",
  "block.minecraft.brick_slab": "Ziegelstufe",
  "block.minecraft.brick_stairs": "Ziegelstäge",
  "block.minecraft.brick_wall": "Ziegelsteimur",
  "block.minecraft.bricks": "Ziegelstei",
  "block.minecraft.brown_banner": "Bruns Banner",
  "block.minecraft.brown_bed": "Bruns Bett",
  "block.minecraft.brown_candle": "Bruni Cherze",
  "block.minecraft.brown_candle_cake": "Chueche mit bruner Cherze",
  "block.minecraft.brown_carpet": "Brune Teppich",
  "block.minecraft.brown_concrete": "Brune Beton",
  "block.minecraft.brown_concrete_powder": "Brune Trochebeton",
  "block.minecraft.brown_glazed_terracotta": "Brune glasierte Keramik",
  "block.minecraft.brown_mushroom": "Brune Pilz",
  "block.minecraft.brown_mushroom_block": "Brune Pilzblock",
  "block.minecraft.brown_shulker_box": "Bruni Shulker-Chiste",
  "block.minecraft.brown_stained_glass": "Bruns Glas",
  "block.minecraft.brown_stained_glass_pane": "Bruni Glasschiibe",
  "block.minecraft.brown_terracotta": "Brune Keramik",
  "block.minecraft.brown_wool": "Bruni Wulle",
  "block.minecraft.bubble_column": "Blosesüüle",
  "block.minecraft.bubble_coral": "Blosekoralle",
  "block.minecraft.bubble_coral_block": "Blosekoralleblock",
  "block.minecraft.bubble_coral_fan": "Blosekorallefächer",
  "block.minecraft.bubble_coral_wall_fan": "Blosekorallewandfächer",
  "block.minecraft.budding_amethyst": "Amethystknospeblock",
  "block.minecraft.bush": "Busch",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kaktusblüete",
  "block.minecraft.cake": "Chueche",
  "block.minecraft.calcite": "Kalzit",
  "block.minecraft.calibrated_sculk_sensor": "Kalibrierte Sculk-Sensor",
  "block.minecraft.campfire": "Lagerfüür",
  "block.minecraft.candle": "Cherze",
  "block.minecraft.candle_cake": "Cherzechueche",
  "block.minecraft.carrots": "Rüebli",
  "block.minecraft.cartography_table": "Chartetisch",
  "block.minecraft.carved_pumpkin": "Gschnitzte Chürbis",
  "block.minecraft.cauldron": "Chessel",
  "block.minecraft.cave_air": "Höhleluft",
  "block.minecraft.cave_vines": "Höhleranke",
  "block.minecraft.cave_vines_plant": "Höhlerankepflanze",
  "block.minecraft.chain": "Chetti",
  "block.minecraft.chain_command_block": "Kette-Befehlsblock",
  "block.minecraft.cherry_button": "Chriesiholzchnopf",
  "block.minecraft.cherry_door": "Chriesiholztür",
  "block.minecraft.cherry_fence": "Chriesiholzhaag",
  "block.minecraft.cherry_fence_gate": "Chriesiholzhaagtor",
  "block.minecraft.cherry_hanging_sign": "Chriesiholzhängeschild",
  "block.minecraft.cherry_leaves": "Chriesilaub",
  "block.minecraft.cherry_log": "Chriesistamm",
  "block.minecraft.cherry_planks": "Chriesiholzbretter",
  "block.minecraft.cherry_pressure_plate": "Chriesiholzdruckplatte",
  "block.minecraft.cherry_sapling": "Chriesisetzling",
  "block.minecraft.cherry_shelf": "Chriesiholzregal",
  "block.minecraft.cherry_sign": "Chriesiholzschild",
  "block.minecraft.cherry_slab": "Chriesiholzstufe",
  "block.minecraft.cherry_stairs": "Chriesiholzstäge",
  "block.minecraft.cherry_trapdoor": "Chriesiholzfalltür",
  "block.minecraft.cherry_wall_hanging_sign": "Chriesiholzwandhängeschild",
  "block.minecraft.cherry_wall_sign": "Chriesiholzwandschild",
  "block.minecraft.cherry_wood": "Chriesiholz",
  "block.minecraft.chest": "Chiste",
  "block.minecraft.chipped_anvil": "Agschlagene Amboss",
  "block.minecraft.chiseled_bookshelf": "Garbeitets Büecherregal",
  "block.minecraft.chiseled_copper": "Gmeisslete Chupferblock",
  "block.minecraft.chiseled_deepslate": "Gmeisslete Tüfschiefer",
  "block.minecraft.chiseled_nether_bricks": "Gmeisslete Netherziegel",
  "block.minecraft.chiseled_polished_blackstone": "Gmeisslete polierte Schwarzstei",
  "block.minecraft.chiseled_quartz_block": "Gmeisslete Quarzblock",
  "block.minecraft.chiseled_red_sandstone": "Gmeisslete rote Sandstei",
  "block.minecraft.chiseled_resin_bricks": "Gmeisslete Harzziegel",
  "block.minecraft.chiseled_sandstone": "Gmeisslete Sandstei",
  "block.minecraft.chiseled_stone_bricks": "Gmeisslete Steiziegel",
  "block.minecraft.chiseled_tuff": "Gmeisslete Tuffstei",
  "block.minecraft.chiseled_tuff_bricks": "Gmeisslete Tuffsteiziegel",
  "block.minecraft.chorus_flower": "Chorusblüete",
  "block.minecraft.chorus_plant": "Choruspflanze",
  "block.minecraft.clay": "Ton",
  "block.minecraft.closed_eyeblossom": "Gschlosseni Augeblüete",
  "block.minecraft.coal_block": "Steicholeblock",
  "block.minecraft.coal_ore": "Steicholeerz",
  "block.minecraft.coarse_dirt": "Grobi Erde",
  "block.minecraft.cobbled_deepslate": "Bruchtüfschiefer",
  "block.minecraft.cobbled_deepslate_slab": "Bruchtüfschieferstufe",
  "block.minecraft.cobbled_deepslate_stairs": "Bruchtüfschieferstäge",
  "block.minecraft.cobbled_deepslate_wall": "Bruchtüfschiefermur",
  "block.minecraft.cobblestone": "Bruchstei",
  "block.minecraft.cobblestone_slab": "Bruchsteistufe",
  "block.minecraft.cobblestone_stairs": "Brochsteistäge",
  "block.minecraft.cobblestone_wall": "Bruchsteimur",
  "block.minecraft.cobweb": "Spinnenetz",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Befehlsblock",
  "block.minecraft.comparator": "Redstone-Komparator",
  "block.minecraft.composter": "Komposter",
  "block.minecraft.conduit": "Aquisator",
  "block.minecraft.copper_bars": "Chupfergitter",
  "block.minecraft.copper_block": "Chupferblock",
  "block.minecraft.copper_bulb": "Chupferlüchte",
  "block.minecraft.copper_chain": "Chupferchetti",
  "block.minecraft.copper_chest": "Chupferchiste",
  "block.minecraft.copper_door": "Chupfertür",
  "block.minecraft.copper_golem_statue": "Chupfergolemstatue",
  "block.minecraft.copper_grate": "Chupferrost",
  "block.minecraft.copper_lantern": "Chupferlaterne",
  "block.minecraft.copper_ore": "Chupfererz",
  "block.minecraft.copper_torch": "Chupferfackle",
  "block.minecraft.copper_trapdoor": "Chupferfalltür",
  "block.minecraft.copper_wall_torch": "Chupferwandfackle",
  "block.minecraft.cornflower": "Chornblueme",
  "block.minecraft.cracked_deepslate_bricks": "Rissigi Tüfschieferziegel",
  "block.minecraft.cracked_deepslate_tiles": "Rissigi Tüfschieferfliese",
  "block.minecraft.cracked_nether_bricks": "Rissigi Netherziegel",
  "block.minecraft.cracked_polished_blackstone_bricks": "Rissigi polierti Schwarzsteiziegel",
  "block.minecraft.cracked_stone_bricks": "Rissige Steiziegel",
  "block.minecraft.crafter": "Werker",
  "block.minecraft.crafting_table": "Werkbank",
  "block.minecraft.creaking_heart": "Chnarzherz",
  "block.minecraft.creeper_head": "Creeperchopf",
  "block.minecraft.creeper_wall_head": "Creeper-Wandchopf",
  "block.minecraft.crimson_button": "Karmesinholzchnopf",
  "block.minecraft.crimson_door": "Karmesinholztür",
  "block.minecraft.crimson_fence": "Karmesinholzhaag",
  "block.minecraft.crimson_fence_gate": "Karmesinholzhaagtor",
  "block.minecraft.crimson_fungus": "Karmesinpilz",
  "block.minecraft.crimson_hanging_sign": "Karmesinholzhängeschild",
  "block.minecraft.crimson_hyphae": "Karmesinhyphe",
  "block.minecraft.crimson_nylium": "Karmesin-Nezel",
  "block.minecraft.crimson_planks": "Karmesinholzbretter",
  "block.minecraft.crimson_pressure_plate": "Karmesinholzdruckplatte",
  "block.minecraft.crimson_roots": "Karmesinwurzle",
  "block.minecraft.crimson_shelf": "Karmesinholzregal",
  "block.minecraft.crimson_sign": "Karmesinholzschild",
  "block.minecraft.crimson_slab": "Karmesinholzstufe",
  "block.minecraft.crimson_stairs": "Karmesinholzstäge",
  "block.minecraft.crimson_stem": "Karmesinstiel",
  "block.minecraft.crimson_trapdoor": "Karmesinholzfalltür",
  "block.minecraft.crimson_wall_hanging_sign": "Karmesinholzwandhängeschild",
  "block.minecraft.crimson_wall_sign": "Karmesinholzwandschild",
  "block.minecraft.crying_obsidian": "Brüelende Obsidian",
  "block.minecraft.cut_copper": "Gschnittene Chupferblock",
  "block.minecraft.cut_copper_slab": "Gschnitteni Chupferstufe",
  "block.minecraft.cut_copper_stairs": "Gschnitteni Chupferstäge",
  "block.minecraft.cut_red_sandstone": "Gschnittene rote Sandstei",
  "block.minecraft.cut_red_sandstone_slab": "Gschnitteni roti Sandsteistufe",
  "block.minecraft.cut_sandstone": "Gschnittene Sandstei",
  "block.minecraft.cut_sandstone_slab": "Gschnitteni Sandsteistufe",
  "block.minecraft.cyan_banner": "Türkises Banner",
  "block.minecraft.cyan_bed": "Türkises Bett",
  "block.minecraft.cyan_candle": "Türkisi Cherze",
  "block.minecraft.cyan_candle_cake": "Chueche mit hellblauer Cherze",
  "block.minecraft.cyan_carpet": "Türkise Teppich",
  "block.minecraft.cyan_concrete": "Türkise Beton",
  "block.minecraft.cyan_concrete_powder": "Türkise Trochebeton",
  "block.minecraft.cyan_glazed_terracotta": "Türkise glasierte Keramik",
  "block.minecraft.cyan_shulker_box": "Türkisi Shulker-Chiste",
  "block.minecraft.cyan_stained_glass": "Türkises Glas",
  "block.minecraft.cyan_stained_glass_pane": "Türkisi Glasschiibe",
  "block.minecraft.cyan_terracotta": "Türkise Keramik",
  "block.minecraft.cyan_wool": "Türkisi Wulle",
  "block.minecraft.damaged_anvil": "Beschädigte Amboss",
  "block.minecraft.dandelion": "Löwezah",
  "block.minecraft.dark_oak_button": "Schwarzeicheholzchnopf",
  "block.minecraft.dark_oak_door": "Schwarzeicheholztür",
  "block.minecraft.dark_oak_fence": "Schwarzeicheholzhaag",
  "block.minecraft.dark_oak_fence_gate": "Schwarzeicheholzhaagtor",
  "block.minecraft.dark_oak_hanging_sign": "Schwarzeicheholzhängeschild",
  "block.minecraft.dark_oak_leaves": "Schwarzeichelaub",
  "block.minecraft.dark_oak_log": "Schwarzeichestamm",
  "block.minecraft.dark_oak_planks": "Schwarzeicheholzbretter",
  "block.minecraft.dark_oak_pressure_plate": "Schwarzeicheholzdruckplatte",
  "block.minecraft.dark_oak_sapling": "Schwarzeichesetzling",
  "block.minecraft.dark_oak_shelf": "Schwarzeicheholzregal",
  "block.minecraft.dark_oak_sign": "Schwarzeicheholzschild",
  "block.minecraft.dark_oak_slab": "Schwarzeicheholzstufe",
  "block.minecraft.dark_oak_stairs": "Schwarzeichestäge",
  "block.minecraft.dark_oak_trapdoor": "Schwarzeicheholzfalltür",
  "block.minecraft.dark_oak_wall_hanging_sign": "Schwarzeicheholzwandhängeschild",
  "block.minecraft.dark_oak_wall_sign": "Schwarzeicheholzwandschild",
  "block.minecraft.dark_oak_wood": "Schwarzeicheholz",
  "block.minecraft.dark_prismarine": "Dunkle Prismarin",
  "block.minecraft.dark_prismarine_slab": "Dunkli Prismarinstufe",
  "block.minecraft.dark_prismarine_stairs": "Dunkli Prismarinstäge",
  "block.minecraft.daylight_detector": "Tageslichtsensor",
  "block.minecraft.dead_brain_coral": "Abgstorbeni Hirnkoralle",
  "block.minecraft.dead_brain_coral_block": "Abgestorbene Hirnkoralleblock",
  "block.minecraft.dead_brain_coral_fan": "Abgstorbeni Hirnkorallefächer",
  "block.minecraft.dead_brain_coral_wall_fan": "Abgstorbeni Hirnkorallewandfächer",
  "block.minecraft.dead_bubble_coral": "Abgstorbeni Blosekoralle",
  "block.minecraft.dead_bubble_coral_block": "Abgestorbene Blosekoralleblock",
  "block.minecraft.dead_bubble_coral_fan": "Abgstorbeni Blosekorallefächer",
  "block.minecraft.dead_bubble_coral_wall_fan": "Abgstorbeni Blasekorallewandfächer",
  "block.minecraft.dead_bush": "Tote Busch",
  "block.minecraft.dead_fire_coral": "Abgstorbeni Füürkoralle",
  "block.minecraft.dead_fire_coral_block": "Abgestorbene Füürkoralleblock",
  "block.minecraft.dead_fire_coral_fan": "Abgstorbeni Füurkorallefächer",
  "block.minecraft.dead_fire_coral_wall_fan": "Abgstorbeni Füürkorallewandfächer",
  "block.minecraft.dead_horn_coral": "Abgstorbeni Geweihkoralle",
  "block.minecraft.dead_horn_coral_block": "Abgestorbene Gweihkoralleblock",
  "block.minecraft.dead_horn_coral_fan": "Abgstorbeni Geweihkorallefächer",
  "block.minecraft.dead_horn_coral_wall_fan": "Abgstorbeni Geweihkorallewandfächer",
  "block.minecraft.dead_tube_coral": "Abgstorbeni Orgelkoralle",
  "block.minecraft.dead_tube_coral_block": "Abgestorbene Orgelkoralleblock",
  "block.minecraft.dead_tube_coral_fan": "Abgstorbeni Orgelkorallefächer",
  "block.minecraft.dead_tube_coral_wall_fan": "Abgstorbeni Orgelkorallwandfächer",
  "block.minecraft.decorated_pot": "Verzierte Chrueg",
  "block.minecraft.deepslate": "Tüfschiefer",
  "block.minecraft.deepslate_brick_slab": "Tüfschieferziegelstufe",
  "block.minecraft.deepslate_brick_stairs": "Tüfschieferziegelstäge",
  "block.minecraft.deepslate_brick_wall": "Tüfschieferziegelmur",
  "block.minecraft.deepslate_bricks": "Tüfschieferziegel",
  "block.minecraft.deepslate_coal_ore": "Tüfschiefer-Steicholeerz",
  "block.minecraft.deepslate_copper_ore": "Tüfschiefer-Chupfererz",
  "block.minecraft.deepslate_diamond_ore": "Tüfschiefer-Diamanterz",
  "block.minecraft.deepslate_emerald_ore": "Tüfschiefer-Smaragderz",
  "block.minecraft.deepslate_gold_ore": "Tüfschiefer-Golderz",
  "block.minecraft.deepslate_iron_ore": "Tüfschiefer-Iiseerz",
  "block.minecraft.deepslate_lapis_ore": "Tüfschiefer-Lapislazulierz",
  "block.minecraft.deepslate_redstone_ore": "Tüfschiefer-Redstone-Erz",
  "block.minecraft.deepslate_tile_slab": "Tüfschieferfliesestufe",
  "block.minecraft.deepslate_tile_stairs": "Tüfschieferfliesestäge",
  "block.minecraft.deepslate_tile_wall": "Tüfschieferfliesemur",
  "block.minecraft.deepslate_tiles": "Tüfschieferfliese",
  "block.minecraft.detector_rail": "Sensorschine",
  "block.minecraft.diamond_block": "Diamantblock",
  "block.minecraft.diamond_ore": "Diamanterz",
  "block.minecraft.diorite": "Diorit",
  "block.minecraft.diorite_slab": "Dioritstufe",
  "block.minecraft.diorite_stairs": "Dioritstäge",
  "block.minecraft.diorite_wall": "Dioritmur",
  "block.minecraft.dirt": "Erde",
  "block.minecraft.dirt_path": "Trampelpfad",
  "block.minecraft.dispenser": "Werfer",
  "block.minecraft.dragon_egg": "Dracheei",
  "block.minecraft.dragon_head": "Drachechopf",
  "block.minecraft.dragon_wall_head": "Drache-Wandchopf",
  "block.minecraft.dried_ghast": "Uströchnete Ghast",
  "block.minecraft.dried_kelp_block": "Tröchnete Seetangblock",
  "block.minecraft.dripstone_block": "Tropfsteiblock",
  "block.minecraft.dropper": "Spender",
  "block.minecraft.emerald_block": "Smaragdblock",
  "block.minecraft.emerald_ore": "Smaragderz",
  "block.minecraft.enchanting_table": "Zaubertisch",
  "block.minecraft.end_gateway": "Endtransitportal",
  "block.minecraft.end_portal": "Endportal",
  "block.minecraft.end_portal_frame": "Endportalrahme",
  "block.minecraft.end_rod": "Endstab",
  "block.minecraft.end_stone": "Endstei",
  "block.minecraft.end_stone_brick_slab": "Endsteiziegelstufe",
  "block.minecraft.end_stone_brick_stairs": "Endsteiziegelstäge",
  "block.minecraft.end_stone_brick_wall": "Endsteiziegelmur",
  "block.minecraft.end_stone_bricks": "Endsteiziegel",
  "block.minecraft.ender_chest": "Enderchiste",
  "block.minecraft.exposed_chiseled_copper": "Agloffene gmeisslete Chupferblock",
  "block.minecraft.exposed_copper": "Agloffene Chupferblock",
  "block.minecraft.exposed_copper_bars": "Agloffens Chupfergitter",
  "block.minecraft.exposed_copper_bulb": "Agloffeni Chupferlüchte",
  "block.minecraft.exposed_copper_chain": "Agloffeni Chupferchetti",
  "block.minecraft.exposed_copper_chest": "Agloffeni Chupferchiste",
  "block.minecraft.exposed_copper_door": "Agloffeni Chupfertür",
  "block.minecraft.exposed_copper_golem_statue": "Agloffeni Chupfergolemstatue",
  "block.minecraft.exposed_copper_grate": "Agloffens Chupferrost",
  "block.minecraft.exposed_copper_lantern": "Agloffeni Chupferlaterne",
  "block.minecraft.exposed_copper_trapdoor": "Agloffeni Chupferfalltür",
  "block.minecraft.exposed_cut_copper": "Agloffene gschnittene Chupferblock",
  "block.minecraft.exposed_cut_copper_slab": "Agloffeni gschnitteni Chupferstufe",
  "block.minecraft.exposed_cut_copper_stairs": "Agloffeni gschnitteni Chupferstäge",
  "block.minecraft.exposed_lightning_rod": "Agloffene Blitzableiter",
  "block.minecraft.farmland": "Ackerbode",
  "block.minecraft.fern": "Farn",
  "block.minecraft.fire": "Füür",
  "block.minecraft.fire_coral": "Füürkoralle",
  "block.minecraft.fire_coral_block": "Füürkoralleblock",
  "block.minecraft.fire_coral_fan": "Füürkorallefächer",
  "block.minecraft.fire_coral_wall_fan": "Füürkorallewandfächer",
  "block.minecraft.firefly_bush": "Glühwürmlibusch",
  "block.minecraft.fletching_table": "Bognertisch",
  "block.minecraft.flower_pot": "Bluemetopf",
  "block.minecraft.flowering_azalea": "Blüehende Azalee",
  "block.minecraft.flowering_azalea_leaves": "Büehends Azaleelaub",
  "block.minecraft.frogspawn": "Froschlaich",
  "block.minecraft.frosted_ice": "Brüchigs Iis",
  "block.minecraft.furnace": "Ofe",
  "block.minecraft.gilded_blackstone": "Golddurchzogene Schwarzstei",
  "block.minecraft.glass": "Glas",
  "block.minecraft.glass_pane": "Glasschiibe",
  "block.minecraft.glow_lichen": "Lüchtflechte",
  "block.minecraft.glowstone": "Lüchtstei",
  "block.minecraft.gold_block": "Goldblock",
  "block.minecraft.gold_ore": "Golderz",
  "block.minecraft.golden_dandelion": "Goldene Löwezah",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Granitstufe",
  "block.minecraft.granite_stairs": "Granitstäge",
  "block.minecraft.granite_wall": "Granitmur",
  "block.minecraft.grass": "Gras",
  "block.minecraft.grass_block": "Grasblock",
  "block.minecraft.gravel": "Chis",
  "block.minecraft.gray_banner": "Graus Banner",
  "block.minecraft.gray_bed": "Graus Bett",
  "block.minecraft.gray_candle": "Graui Cherze",
  "block.minecraft.gray_candle_cake": "Chueche mit grauer Cherze",
  "block.minecraft.gray_carpet": "Graue Teppich",
  "block.minecraft.gray_concrete": "Graue Beton",
  "block.minecraft.gray_concrete_powder": "Graue Trochebeton",
  "block.minecraft.gray_glazed_terracotta": "Grau glasierte Keramik",
  "block.minecraft.gray_shulker_box": "Graui Shulker-Chiste",
  "block.minecraft.gray_stained_glass": "Graus Glas",
  "block.minecraft.gray_stained_glass_pane": "Graui Glasschiibe",
  "block.minecraft.gray_terracotta": "Graue Keramik",
  "block.minecraft.gray_wool": "Graui Wulle",
  "block.minecraft.green_banner": "Grüens Banner",
  "block.minecraft.green_bed": "Grüens Bett",
  "block.minecraft.green_candle": "Grüeni Cherze",
  "block.minecraft.green_candle_cake": "Chueche mit grüener Cherze",
  "block.minecraft.green_carpet": "Grüene Teppich",
  "block.minecraft.green_concrete": "Grüene Beton",
  "block.minecraft.green_concrete_powder": "Grüene Trochebeton",
  "block.minecraft.green_glazed_terracotta": "Grüene glasierte Keramik",
  "block.minecraft.green_shulker_box": "Grüeni Shulker-Chiste",
  "block.minecraft.green_stained_glass": "Grüens Glas",
  "block.minecraft.green_stained_glass_pane": "Grüeni Glasschiibe",
  "block.minecraft.green_terracotta": "Grüene Keramik",
  "block.minecraft.green_wool": "Grüeni Wulle",
  "block.minecraft.grindstone": "Schliifstei",
  "block.minecraft.hanging_roots": "Hängendi Wurzle",
  "block.minecraft.hay_block": "Heuballe",
  "block.minecraft.heavy_core": "Schwere Kern",
  "block.minecraft.heavy_weighted_pressure_plate": "Grobwägplatte",
  "block.minecraft.honey_block": "Honigblock",
  "block.minecraft.honeycomb_block": "Honigwabeblock",
  "block.minecraft.hopper": "Trichter",
  "block.minecraft.horn_coral": "Gweihkoralle",
  "block.minecraft.horn_coral_block": "Gweihkoralleblock",
  "block.minecraft.horn_coral_fan": "Gweihkorallefächer",
  "block.minecraft.horn_coral_wall_fan": "Geweihkorallwandfächer",
  "block.minecraft.ice": "Iis",
  "block.minecraft.infested_chiseled_stone_bricks": "Befallene gmeisslete Steiziegel",
  "block.minecraft.infested_cobblestone": "Infizierte Buchstei",
  "block.minecraft.infested_cracked_stone_bricks": "Infizierte rissige Steiziegel",
  "block.minecraft.infested_deepslate": "Befallene Tüfschiefer",
  "block.minecraft.infested_mossy_stone_bricks": "Infizierte bemooste Steiziegel",
  "block.minecraft.infested_stone": "Infizierte Stei",
  "block.minecraft.infested_stone_bricks": "Infizierte Steiziegel",
  "block.minecraft.iron_bars": "Iisegitter",
  "block.minecraft.iron_block": "Iiseblock",
  "block.minecraft.iron_chain": "Iisechetti",
  "block.minecraft.iron_door": "Iisetür",
  "block.minecraft.iron_ore": "Iiseerz",
  "block.minecraft.iron_trapdoor": "Iisefalltür",
  "block.minecraft.jack_o_lantern": "Chürbislaterne",
  "block.minecraft.jigsaw": "Verbundblock",
  "block.minecraft.jukebox": "Plattespieler",
  "block.minecraft.jungle_button": "Tropeholzchnopf",
  "block.minecraft.jungle_door": "Tropeholztür",
  "block.minecraft.jungle_fence": "Tropeholzhaag",
  "block.minecraft.jungle_fence_gate": "Tropeholzhaagtor",
  "block.minecraft.jungle_hanging_sign": "Tropeholzhängeschild",
  "block.minecraft.jungle_leaves": "Tropelaub",
  "block.minecraft.jungle_log": "Tropestamm",
  "block.minecraft.jungle_planks": "Tropeholzbretter",
  "block.minecraft.jungle_pressure_plate": "Tropeholzdruckplatte",
  "block.minecraft.jungle_sapling": "Tropesetzling",
  "block.minecraft.jungle_shelf": "Tropeholzregal",
  "block.minecraft.jungle_sign": "Tropeholzschild",
  "block.minecraft.jungle_slab": "Tropeholzstufe",
  "block.minecraft.jungle_stairs": "Tropeholzstäge",
  "block.minecraft.jungle_trapdoor": "Tropeholzfalltür",
  "block.minecraft.jungle_wall_hanging_sign": "Tropeholzwandhängeschild",
  "block.minecraft.jungle_wall_sign": "Tropeholzwandschild",
  "block.minecraft.jungle_wood": "Tropeholz",
  "block.minecraft.kelp": "Seetang",
  "block.minecraft.kelp_plant": "Seetangstängel",
  "block.minecraft.ladder": "Leitere",
  "block.minecraft.lantern": "Laterne",
  "block.minecraft.lapis_block": "Lapislazuliblock",
  "block.minecraft.lapis_ore": "Lapislazulierz",
  "block.minecraft.large_amethyst_bud": "Grossi Amethystknospe",
  "block.minecraft.large_fern": "Grosse Farn",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Lavachessel",
  "block.minecraft.leaf_litter": "Laubhuufe",
  "block.minecraft.lectern": "Lesepult",
  "block.minecraft.lever": "Hebel",
  "block.minecraft.light": "Liechtblock",
  "block.minecraft.light_blue_banner": "Hellblaus Banner",
  "block.minecraft.light_blue_bed": "Hellblaus Bett",
  "block.minecraft.light_blue_candle": "Hellblaui Cherze",
  "block.minecraft.light_blue_candle_cake": "Chueche mit hellblauer Cherze",
  "block.minecraft.light_blue_carpet": "Hellblaue Teppich",
  "block.minecraft.light_blue_concrete": "Hellblaue Beton",
  "block.minecraft.light_blue_concrete_powder": "Hellblaue Trochebeton",
  "block.minecraft.light_blue_glazed_terracotta": "Hellblaue glasierte Keramik",
  "block.minecraft.light_blue_shulker_box": "Hellblaui Shulker-Chiste",
  "block.minecraft.light_blue_stained_glass": "Hellblaus Glas",
  "block.minecraft.light_blue_stained_glass_pane": "Hellblaui Glasschiibe",
  "block.minecraft.light_blue_terracotta": "Hellblaue Keramik",
  "block.minecraft.light_blue_wool": "Hellblaui Wulle",
  "block.minecraft.light_gray_banner": "Hellgrüens Banner",
  "block.minecraft.light_gray_bed": "Hellgraus Bett",
  "block.minecraft.light_gray_candle": "Hellgraui Cherze",
  "block.minecraft.light_gray_candle_cake": "Chueche mit hellgrauer Cherze",
  "block.minecraft.light_gray_carpet": "Hellgraue Teppich",
  "block.minecraft.light_gray_concrete": "Hellgraue Beton",
  "block.minecraft.light_gray_concrete_powder": "Hellgraue Trochebeton",
  "block.minecraft.light_gray_glazed_terracotta": "Hellgrau glasierte Keramik",
  "block.minecraft.light_gray_shulker_box": "Hellgraui Shulker-Chiste",
  "block.minecraft.light_gray_stained_glass": "Hellgraus Glas",
  "block.minecraft.light_gray_stained_glass_pane": "Hellgraui Glasschiibe",
  "block.minecraft.light_gray_terracotta": "Hellgraue Keramik",
  "block.minecraft.light_gray_wool": "Hellgraui Wulle",
  "block.minecraft.light_weighted_pressure_plate": "Fiiwägplatte",
  "block.minecraft.lightning_rod": "Blitzableiter",
  "block.minecraft.lilac": "Flieder",
  "block.minecraft.lily_of_the_valley": "Maiglöckli",
  "block.minecraft.lily_pad": "Seeroseblatt",
  "block.minecraft.lime_banner": "Hellgrüens Banner",
  "block.minecraft.lime_bed": "Hellgrüens Bett",
  "block.minecraft.lime_candle": "Hellgrüeni Cherze",
  "block.minecraft.lime_candle_cake": "Chueche mit hellgrüener Cherze",
  "block.minecraft.lime_carpet": "Hellgrüene Teppich",
  "block.minecraft.lime_concrete": "Hellgrüene Beton",
  "block.minecraft.lime_concrete_powder": "Hellgrüene Trochebeton",
  "block.minecraft.lime_glazed_terracotta": "Hellgrüene glasierte Keramik",
  "block.minecraft.lime_shulker_box": "Hellgrüeni Shulker-Chiste",
  "block.minecraft.lime_stained_glass": "Hellgrüens Glas",
  "block.minecraft.lime_stained_glass_pane": "Hellgrüeni Glasschiibe",
  "block.minecraft.lime_terracotta": "Hellgrüene Keramik",
  "block.minecraft.lime_wool": "Hellgrüeni Wulle",
  "block.minecraft.lodestone": "Leitstei",
  "block.minecraft.loom": "Webstuehl",
  "block.minecraft.magenta_banner": "Magenta Banner",
  "block.minecraft.magenta_bed": "Magenta Bett",
  "block.minecraft.magenta_candle": "Magenta Cherze",
  "block.minecraft.magenta_candle_cake": "Chueche mit magenta Cherze",
  "block.minecraft.magenta_carpet": "Magenta Teppich",
  "block.minecraft.magenta_concrete": "Magenta Beton",
  "block.minecraft.magenta_concrete_powder": "Magenta Trochebeton",
  "block.minecraft.magenta_glazed_terracotta": "Magenta glasierte Keramik",
  "block.minecraft.magenta_shulker_box": "Magenta Shulker-Chiste",
  "block.minecraft.magenta_stained_glass": "Magenta Glas",
  "block.minecraft.magenta_stained_glass_pane": "Magenta Glasschiibe",
  "block.minecraft.magenta_terracotta": "Magenta Keramik",
  "block.minecraft.magenta_wool": "Magenta Wulle",
  "block.minecraft.magma_block": "Magmablock",
  "block.minecraft.mangrove_button": "Mangroveholzchnopf",
  "block.minecraft.mangrove_door": "Mangroveholztür",
  "block.minecraft.mangrove_fence": "Mangroveholzhaag",
  "block.minecraft.mangrove_fence_gate": "Mangroveholzhaagtor",
  "block.minecraft.mangrove_hanging_sign": "Mangroveholzhängeschild",
  "block.minecraft.mangrove_leaves": "Mangrovelaub",
  "block.minecraft.mangrove_log": "Mangrovestamm",
  "block.minecraft.mangrove_planks": "Mangroveholzbretter",
  "block.minecraft.mangrove_pressure_plate": "Mangroveholzdruckplatte",
  "block.minecraft.mangrove_propagule": "Mangrove-Keimling",
  "block.minecraft.mangrove_roots": "Mangrovewurzle",
  "block.minecraft.mangrove_shelf": "Mangroveholzregal",
  "block.minecraft.mangrove_sign": "Mangroveholzschild",
  "block.minecraft.mangrove_slab": "Mangroveholzstufe",
  "block.minecraft.mangrove_stairs": "Mangroveholzstäge",
  "block.minecraft.mangrove_trapdoor": "Mangroveholzfalltür",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangroveholzwandhängeschild",
  "block.minecraft.mangrove_wall_sign": "Mangroveholzwandschild",
  "block.minecraft.mangrove_wood": "Mangroveholz",
  "block.minecraft.medium_amethyst_bud": "Mittleri Amethystknospe",
  "block.minecraft.melon": "Melone",
  "block.minecraft.melon_stem": "Melonepflanze",
  "block.minecraft.moss_block": "Moosblock",
  "block.minecraft.moss_carpet": "Moosteppich",
  "block.minecraft.mossy_cobblestone": "Bemooste Bruchstei",
  "block.minecraft.mossy_cobblestone_slab": "Bemoosti Bruchsteistufe",
  "block.minecraft.mossy_cobblestone_stairs": "Bemoosti Bruchsteitstäge",
  "block.minecraft.mossy_cobblestone_wall": "Bemoosti Bruchsteimur",
  "block.minecraft.mossy_stone_brick_slab": "Bemoosti Steiziegelstufe",
  "block.minecraft.mossy_stone_brick_stairs": "Bemoosti Steiziegelstäge",
  "block.minecraft.mossy_stone_brick_wall": "Bemoosti Steiziegelmur",
  "block.minecraft.mossy_stone_bricks": "Bemooste Steiziegel",
  "block.minecraft.moving_piston": "Bewegte Block",
  "block.minecraft.mud": "Schlamm",
  "block.minecraft.mud_brick_slab": "Schlammziegelstufe",
  "block.minecraft.mud_brick_stairs": "Schlammziegelstäge",
  "block.minecraft.mud_brick_wall": "Schlammziegelmuur",
  "block.minecraft.mud_bricks": "Schlammziegel",
  "block.minecraft.muddy_mangrove_roots": "Schlammigi Mangrovewurzle",
  "block.minecraft.mushroom_stem": "Pilzstiel",
  "block.minecraft.mycelium": "Myzel",
  "block.minecraft.nether_brick_fence": "Netherziegelhaag",
  "block.minecraft.nether_brick_slab": "Netherziegelstufe",
  "block.minecraft.nether_brick_stairs": "Netherziegelstäge",
  "block.minecraft.nether_brick_wall": "Netherziegelmur",
  "block.minecraft.nether_bricks": "Netherziegel",
  "block.minecraft.nether_gold_ore": "Nethergolderz",
  "block.minecraft.nether_portal": "Netherportal",
  "block.minecraft.nether_quartz_ore": "Netherquarzerz",
  "block.minecraft.nether_sprouts": "Nethersprosse",
  "block.minecraft.nether_wart": "Netherwarze",
  "block.minecraft.nether_wart_block": "Netherwarzeblock",
  "block.minecraft.netherite_block": "Netheritblock",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Noteblock",
  "block.minecraft.oak_button": "Eicheholzchnopf",
  "block.minecraft.oak_door": "Eicheholztür",
  "block.minecraft.oak_fence": "Eicheholzhaag",
  "block.minecraft.oak_fence_gate": "Eicheholzhaagtor",
  "block.minecraft.oak_hanging_sign": "Eicheholzhängeschild",
  "block.minecraft.oak_leaves": "Eichelaub",
  "block.minecraft.oak_log": "Eichestamm",
  "block.minecraft.oak_planks": "Eicheholzbretter",
  "block.minecraft.oak_pressure_plate": "Eicheholzdruckplatte",
  "block.minecraft.oak_sapling": "Eichesetzling",
  "block.minecraft.oak_shelf": "Eicheholzregal",
  "block.minecraft.oak_sign": "Eicheholzschild",
  "block.minecraft.oak_slab": "Eicheholzstufe",
  "block.minecraft.oak_stairs": "Eicheholzstäge",
  "block.minecraft.oak_trapdoor": "Eicheholzfalltür",
  "block.minecraft.oak_wall_hanging_sign": "Eicheholzwandhängeschild",
  "block.minecraft.oak_wall_sign": "Eicheholzwandschild",
  "block.minecraft.oak_wood": "Eicheholz",
  "block.minecraft.observer": "Beobachter",
  "block.minecraft.obsidian": "Obsidian",
  "block.minecraft.ochre_froglight": "Ockerni Froschlampe",
  "block.minecraft.ominous_banner": "Ominöses Banner",
  "block.minecraft.open_eyeblossom": "Göffneti Augeblüete",
  "block.minecraft.orange_banner": "Oranges Banner",
  "block.minecraft.orange_bed": "Oranges Bett",
  "block.minecraft.orange_candle": "Orangi Cherze",
  "block.minecraft.orange_candle_cake": "Chueche mit orangener Cherze",
  "block.minecraft.orange_carpet": "Orange Teppich",
  "block.minecraft.orange_concrete": "Orange Beton",
  "block.minecraft.orange_concrete_powder": "Orange Trochebeton",
  "block.minecraft.orange_glazed_terracotta": "Orange glasierte Keramik",
  "block.minecraft.orange_shulker_box": "Orangi Shulker-Chiste",
  "block.minecraft.orange_stained_glass": "Oranges Glas",
  "block.minecraft.orange_stained_glass_pane": "Orangi Glasschiibe",
  "block.minecraft.orange_terracotta": "Orange Keramik",
  "block.minecraft.orange_tulip": "Orangi Tulpe",
  "block.minecraft.orange_wool": "Orangi Wulle",
  "block.minecraft.oxeye_daisy": "Margeritli",
  "block.minecraft.oxidized_chiseled_copper": "Oxidierte gmeisslete Chupferblock",
  "block.minecraft.oxidized_copper": "Oxidierte Chupferblock",
  "block.minecraft.oxidized_copper_bars": "Oxidierts Chupfergitter",
  "block.minecraft.oxidized_copper_bulb": "Oxidierti Chupferlüchti",
  "block.minecraft.oxidized_copper_chain": "Oxidierti Chupferchetti",
  "block.minecraft.oxidized_copper_chest": "Oxidierti Chupferchiste",
  "block.minecraft.oxidized_copper_door": "Oxidierti Chupfertür",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidierti Chupfergolemstatue",
  "block.minecraft.oxidized_copper_grate": "Oxidierts Chupferrost",
  "block.minecraft.oxidized_copper_lantern": "Oxidierti Chupferlaterne",
  "block.minecraft.oxidized_copper_trapdoor": "Oxidierti Chupferfalltür",
  "block.minecraft.oxidized_cut_copper": "Oxidierte gschnittene Chupferblock",
  "block.minecraft.oxidized_cut_copper_slab": "Oxidierti gschnitteni Chupferstufe",
  "block.minecraft.oxidized_cut_copper_stairs": "Oxidierti gschnitteni Chupferstäge",
  "block.minecraft.oxidized_lightning_rod": "Oxidierte Blitzableiter",
  "block.minecraft.packed_ice": "Packiis",
  "block.minecraft.packed_mud": "Presste Schlamm",
  "block.minecraft.pale_hanging_moss": "Hängends Blassmoos",
  "block.minecraft.pale_moss_block": "Blassmoosblock",
  "block.minecraft.pale_moss_carpet": "Blassmossteppich",
  "block.minecraft.pale_oak_button": "Blasseicheholzchnopf",
  "block.minecraft.pale_oak_door": "Blasseicheholztüre",
  "block.minecraft.pale_oak_fence": "Blasseicheholzhaag",
  "block.minecraft.pale_oak_fence_gate": "Blasseicheholzhaagtor",
  "block.minecraft.pale_oak_hanging_sign": "Blasseicheholzhängeschild",
  "block.minecraft.pale_oak_leaves": "Blasseichelaub",
  "block.minecraft.pale_oak_log": "Blasseichestamm",
  "block.minecraft.pale_oak_planks": "Blasseicheholzbretter",
  "block.minecraft.pale_oak_pressure_plate": "Blasseicheholzdruckplatte",
  "block.minecraft.pale_oak_sapling": "Blasseichesetzling",
  "block.minecraft.pale_oak_shelf": "Blasseicheholzregal",
  "block.minecraft.pale_oak_sign": "Blasseicheholzschild",
  "block.minecraft.pale_oak_slab": "Blasseicheholzstufe",
  "block.minecraft.pale_oak_stairs": "Blasseicheholzstäge",
  "block.minecraft.pale_oak_trapdoor": "Blasseicheholzfalltüre",
  "block.minecraft.pale_oak_wall_hanging_sign": "Blasseicheholzwandhängeschild",
  "block.minecraft.pale_oak_wall_sign": "Blasseicheholzwandschild",
  "block.minecraft.pale_oak_wood": "Blasseicheholz",
  "block.minecraft.pearlescent_froglight": "Perlmuetterni Froschlampe",
  "block.minecraft.peony": "Pfingstrose",
  "block.minecraft.petrified_oak_slab": "Versteinerti Eicheholzstufe",
  "block.minecraft.piglin_head": "Piglinchopf",
  "block.minecraft.piglin_wall_head": "Piglin-Wandchopf",
  "block.minecraft.pink_banner": "Rosa Banner",
  "block.minecraft.pink_bed": "Rosa Bett",
  "block.minecraft.pink_candle": "Rosa Cherze",
  "block.minecraft.pink_candle_cake": "Chueche mit rosa Cherze",
  "block.minecraft.pink_carpet": "Rosa Teppich",
  "block.minecraft.pink_concrete": "Rosa Beton",
  "block.minecraft.pink_concrete_powder": "Pinke Trochebeton",
  "block.minecraft.pink_glazed_terracotta": "Rosa glasierte Keramik",
  "block.minecraft.pink_petals": "Rosa Blüeteblätter",
  "block.minecraft.pink_shulker_box": "Rosa Shulker-Chiste",
  "block.minecraft.pink_stained_glass": "Rosa Glas",
  "block.minecraft.pink_stained_glass_pane": "Rosa Glasschiibe",
  "block.minecraft.pink_terracotta": "Rosa Keramik",
  "block.minecraft.pink_tulip": "Rosa Tulpe",
  "block.minecraft.pink_wool": "Rosa Wulle",
  "block.minecraft.piston": "Cholbe",
  "block.minecraft.piston_head": "Cholbechopf",
  "block.minecraft.pitcher_crop": "Channepflanzetrieb",
  "block.minecraft.pitcher_plant": "Channepflanze",
  "block.minecraft.player_head": "Spielerchopf",
  "block.minecraft.player_head.named": "Chopf vo %s",
  "block.minecraft.player_wall_head": "Spieler-Wandchopf",
  "block.minecraft.podzol": "Podsol",
  "block.minecraft.pointed_dripstone": "Spitze Tropfstei",
  "block.minecraft.polished_andesite": "Polierte Andesit",
  "block.minecraft.polished_andesite_slab": "Polierti Andesitstufe",
  "block.minecraft.polished_andesite_stairs": "Polierti Andesitstäge",
  "block.minecraft.polished_basalt": "Polierte Basalt",
  "block.minecraft.polished_blackstone": "Polierte Schwarzstei",
  "block.minecraft.polished_blackstone_brick_slab": "Polierti Schwarzsteiziegelstufe",
  "block.minecraft.polished_blackstone_brick_stairs": "Polierti Schwarzsteiziegelstäge",
  "block.minecraft.polished_blackstone_brick_wall": "Polierti Schwarzsteiziegelmur",
  "block.minecraft.polished_blackstone_bricks": "Polierti Schwarzsteiziegel",
  "block.minecraft.polished_blackstone_button": "Polierte Schwarzsteichnopf",
  "block.minecraft.polished_blackstone_pressure_plate": "Polierti Schwarzsteidruckplatte",
  "block.minecraft.polished_blackstone_slab": "Polierti Schwarzsteistufe",
  "block.minecraft.polished_blackstone_stairs": "Polierti Schwarzsteistäge",
  "block.minecraft.polished_blackstone_wall": "Polierti Schwarzsteimur",
  "block.minecraft.polished_deepslate": "Polierte Tüfschiefer",
  "block.minecraft.polished_deepslate_slab": "Polierti Tüfschieferstufe",
  "block.minecraft.polished_deepslate_stairs": "Polierti Tüfschieferstäge",
  "block.minecraft.polished_deepslate_wall": "Polierti Tüfschiefermur",
  "block.minecraft.polished_diorite": "Polierte Diorit",
  "block.minecraft.polished_diorite_slab": "Polierti Dioritstufe",
  "block.minecraft.polished_diorite_stairs": "Polierti Dioritstäge",
  "block.minecraft.polished_granite": "Polierte Granit",
  "block.minecraft.polished_granite_slab": "Polierti Granitstufe",
  "block.minecraft.polished_granite_stairs": "Polierti Granitstäge",
  "block.minecraft.polished_tuff": "Polierte Tuffstei",
  "block.minecraft.polished_tuff_slab": "Polierti Tuffsteistufe",
  "block.minecraft.polished_tuff_stairs": "Polierti Tuffsteistäge",
  "block.minecraft.polished_tuff_wall": "Polierti Tuffsteimuur",
  "block.minecraft.poppy": "Mohn",
  "block.minecraft.potatoes": "Härdöpfel",
  "block.minecraft.potted_acacia_sapling": "Iitopfte Akaziesetzling",
  "block.minecraft.potted_allium": "Iitopfte Zierlauch",
  "block.minecraft.potted_azalea_bush": "Iitopfte Azalee",
  "block.minecraft.potted_azure_bluet": "Iitopfts Porzellansternli",
  "block.minecraft.potted_bamboo": "Iitopfte Bambus",
  "block.minecraft.potted_birch_sapling": "Iitopfte Birkesetzling",
  "block.minecraft.potted_blue_orchid": "Iitopfti blaui Orchidee",
  "block.minecraft.potted_brown_mushroom": "Iitopfte brune Pilz",
  "block.minecraft.potted_cactus": "Iitopfte Kaktus",
  "block.minecraft.potted_cherry_sapling": "Iitopfte Chriesisetzling",
  "block.minecraft.potted_closed_eyeblossom": "Iitopfti gschlosseni Augeblüete",
  "block.minecraft.potted_cornflower": "Iitopfti Chornblueme",
  "block.minecraft.potted_crimson_fungus": "Iitopfte Karmesinpilz",
  "block.minecraft.potted_crimson_roots": "Iitopfti Karmesinwurzle",
  "block.minecraft.potted_dandelion": "Iitopfte Löwezah",
  "block.minecraft.potted_dark_oak_sapling": "Iitopfte Schwarzeichesetzling",
  "block.minecraft.potted_dead_bush": "Iitopfte tote Busch",
  "block.minecraft.potted_fern": "Iitopfte Farn",
  "block.minecraft.potted_flowering_azalea_bush": "Iitopfte blüehende Azalee",
  "block.minecraft.potted_golden_dandelion": "Iitopfte goldene Löwezah",
  "block.minecraft.potted_jungle_sapling": "Iitopfte Tropesetzling",
  "block.minecraft.potted_lily_of_the_valley": "Iitopfts Maiglöckli",
  "block.minecraft.potted_mangrove_propagule": "Iitopfte Mangrove-Keimling",
  "block.minecraft.potted_oak_sapling": "Iitopfte Eichesetzling",
  "block.minecraft.potted_open_eyeblossom": "Iitopfti göffneti Augeblüete",
  "block.minecraft.potted_orange_tulip": "Iitopfti orangi Tulpe",
  "block.minecraft.potted_oxeye_daisy": "Iitopfts Margeritli",
  "block.minecraft.potted_pale_oak_sapling": "Iitopfte Blasseichesetzling",
  "block.minecraft.potted_pink_tulip": "Iitopfti rosa Tulpe",
  "block.minecraft.potted_poppy": "Iitopfte Mohn",
  "block.minecraft.potted_red_mushroom": "Iitopfte rote Pilz",
  "block.minecraft.potted_red_tulip": "Iitopfti roti Tulpe",
  "block.minecraft.potted_spruce_sapling": "Iitopfte Fichtesetzling",
  "block.minecraft.potted_torchflower": "Iitopfti Fackellilie",
  "block.minecraft.potted_warped_fungus": "Iitopfte Wirrpilz",
  "block.minecraft.potted_warped_roots": "Iitopfti Wirrwurzle",
  "block.minecraft.potted_white_tulip": "Iitopfti wiissi Tulpe",
  "block.minecraft.potted_wither_rose": "Iitopfti Wither-Rose",
  "block.minecraft.powder_snow": "Pulverschnee",
  "block.minecraft.powder_snow_cauldron": "Pulverschneechessel",
  "block.minecraft.powered_rail": "Atriebsschine",
  "block.minecraft.prismarine": "Prismarin",
  "block.minecraft.prismarine_brick_slab": "Prismarinziegelstufe",
  "block.minecraft.prismarine_brick_stairs": "Prismarinziegelstäge",
  "block.minecraft.prismarine_bricks": "Prismarinziegel",
  "block.minecraft.prismarine_slab": "Prismarinstufe",
  "block.minecraft.prismarine_stairs": "Prismarinstäge",
  "block.minecraft.prismarine_wall": "Prismarinmur",
  "block.minecraft.pumpkin": "Chürbis",
  "block.minecraft.pumpkin_stem": "Chürbispflanze",
  "block.minecraft.purple_banner": "Violetts Banner",
  "block.minecraft.purple_bed": "Violetts Bett",
  "block.minecraft.purple_candle": "Violetti Cherze",
  "block.minecraft.purple_candle_cake": "Chueche mit violetter Cherze",
  "block.minecraft.purple_carpet": "Violette Teppich",
  "block.minecraft.purple_concrete": "Violette Beton",
  "block.minecraft.purple_concrete_powder": "Violette Trochebeton",
  "block.minecraft.purple_glazed_terracotta": "Violette glasierte Keramik",
  "block.minecraft.purple_shulker_box": "Violetti Shulker-Chiste",
  "block.minecraft.purple_stained_glass": "Violetts Glas",
  "block.minecraft.purple_stained_glass_pane": "Violetti Glasschiibe",
  "block.minecraft.purple_terracotta": "Violette Keramik",
  "block.minecraft.purple_wool": "Violetti Wulle",
  "block.minecraft.purpur_block": "Purpurblock",
  "block.minecraft.purpur_pillar": "Purpursüle",
  "block.minecraft.purpur_slab": "Purpurstufe",
  "block.minecraft.purpur_stairs": "Purpurstäge",
  "block.minecraft.quartz_block": "Quarzblock",
  "block.minecraft.quartz_bricks": "Quarzziegel",
  "block.minecraft.quartz_pillar": "Quarzsüüle",
  "block.minecraft.quartz_slab": "Quarzstufe",
  "block.minecraft.quartz_stairs": "Quarzstäge",
  "block.minecraft.rail": "Schine",
  "block.minecraft.raw_copper_block": "Rohchupferblock",
  "block.minecraft.raw_gold_block": "Rohgoldblock",
  "block.minecraft.raw_iron_block": "Rohiiseblock",
  "block.minecraft.red_banner": "Rots Banner",
  "block.minecraft.red_bed": "Rots Bett",
  "block.minecraft.red_candle": "Roti Cherze",
  "block.minecraft.red_candle_cake": "Chueche mit roter Cherze",
  "block.minecraft.red_carpet": "Rote Teppich",
  "block.minecraft.red_concrete": "Rote Beton",
  "block.minecraft.red_concrete_powder": "Rote Trochebeton",
  "block.minecraft.red_glazed_terracotta": "Rote glasierte Keramik",
  "block.minecraft.red_mushroom": "Rote Pilz",
  "block.minecraft.red_mushroom_block": "Rote Pilzblock",
  "block.minecraft.red_nether_brick_slab": "Roti Netherziegelstufe",
  "block.minecraft.red_nether_brick_stairs": "Roti Netherziegelstäge",
  "block.minecraft.red_nether_brick_wall": "Roti Netherziegelmur",
  "block.minecraft.red_nether_bricks": "Roti Netherziegel",
  "block.minecraft.red_sand": "Rote Sand",
  "block.minecraft.red_sandstone": "Rote Standstei",
  "block.minecraft.red_sandstone_slab": "Roti Sandsteistufe",
  "block.minecraft.red_sandstone_stairs": "Roti Sandsteistäge",
  "block.minecraft.red_sandstone_wall": "Roti Sandsteimur",
  "block.minecraft.red_shulker_box": "Roti Shulker-Chiste",
  "block.minecraft.red_stained_glass": "Rots Glas",
  "block.minecraft.red_stained_glass_pane": "Roti Glasschiibe",
  "block.minecraft.red_terracotta": "Rote Keramik",
  "block.minecraft.red_tulip": "Roti Tulpe",
  "block.minecraft.red_wool": "Roti Wulle",
  "block.minecraft.redstone_block": "Redstone-Block",
  "block.minecraft.redstone_lamp": "Redstone-Lampe",
  "block.minecraft.redstone_ore": "Redstone-Erz",
  "block.minecraft.redstone_torch": "Redstone-Fackle",
  "block.minecraft.redstone_wall_torch": "Redstone-Wandfackle",
  "block.minecraft.redstone_wire": "Redstone-Leitig",
  "block.minecraft.reinforced_deepslate": "Verstärkte Tüfschiefer",
  "block.minecraft.repeater": "Redstone-Verstärker",
  "block.minecraft.repeating_command_block": "Wiederhol-Befehlsblock",
  "block.minecraft.resin_block": "Harzblock",
  "block.minecraft.resin_brick_slab": "Harzziegelstufe",
  "block.minecraft.resin_brick_stairs": "Harzziegelstäge",
  "block.minecraft.resin_brick_wall": "Harzziegelmur",
  "block.minecraft.resin_bricks": "Harzziegel",
  "block.minecraft.resin_clump": "Harzchlumpe",
  "block.minecraft.respawn_anchor": "Seeleanker",
  "block.minecraft.rooted_dirt": "Wurzelerde",
  "block.minecraft.rose_bush": "Rosestruch",
  "block.minecraft.sand": "Sand",
  "block.minecraft.sandstone": "Sandstei",
  "block.minecraft.sandstone_slab": "Sandsteistufe",
  "block.minecraft.sandstone_stairs": "Sandsteistäge",
  "block.minecraft.sandstone_wall": "Sandsteimur",
  "block.minecraft.scaffolding": "Grüst",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculk-Katalysator",
  "block.minecraft.sculk_sensor": "Sculk-Sensor",
  "block.minecraft.sculk_shrieker": "Sculk-Kreischer",
  "block.minecraft.sculk_vein": "Sculk-Ader",
  "block.minecraft.sea_lantern": "Seelaterne",
  "block.minecraft.sea_pickle": "Meeresgurke",
  "block.minecraft.seagrass": "Seegras",
  "block.minecraft.set_spawn": "Wiederiistigspunkt gsetzt",
  "block.minecraft.short_dry_grass": "Niedrigs Trockegras",
  "block.minecraft.short_grass": "Niedrigs Gras",
  "block.minecraft.shroomlight": "Pilzliecht",
  "block.minecraft.shulker_box": "Shulker-Chiste",
  "block.minecraft.skeleton_skull": "Skelettschädel",
  "block.minecraft.skeleton_wall_skull": "Skelett-Wandschädel",
  "block.minecraft.slime_block": "Schliimblock",
  "block.minecraft.small_amethyst_bud": "Chliini Amethystknospe",
  "block.minecraft.small_dripleaf": "Chliises Tropfblatt",
  "block.minecraft.smithing_table": "Schmiedtisch",
  "block.minecraft.smoker": "Rücherofe",
  "block.minecraft.smooth_basalt": "Glatte Basalt",
  "block.minecraft.smooth_quartz": "Glatte Quarzblock",
  "block.minecraft.smooth_quartz_slab": "Glatti Quarzstufe",
  "block.minecraft.smooth_quartz_stairs": "Glatti Quarzstäge",
  "block.minecraft.smooth_red_sandstone": "Glatte rote Sandstei",
  "block.minecraft.smooth_red_sandstone_slab": "Glatti roti Sandsteistufe",
  "block.minecraft.smooth_red_sandstone_stairs": "Glatti roti Sandsteistäge",
  "block.minecraft.smooth_sandstone": "Glatte Sandstei",
  "block.minecraft.smooth_sandstone_slab": "Glatti Sandsteistufe",
  "block.minecraft.smooth_sandstone_stairs": "Glatti Sandsteistäge",
  "block.minecraft.smooth_stone": "Glatte Stei",
  "block.minecraft.smooth_stone_slab": "Glatti Steistufe",
  "block.minecraft.sniffer_egg": "Schnüffler-Ei",
  "block.minecraft.snow": "Schnee",
  "block.minecraft.snow_block": "Schneeblock",
  "block.minecraft.soul_campfire": "Seelelagerfüür",
  "block.minecraft.soul_fire": "Seelefüür",
  "block.minecraft.soul_lantern": "Seelelaterne",
  "block.minecraft.soul_sand": "Seelesand",
  "block.minecraft.soul_soil": "Seeleerde",
  "block.minecraft.soul_torch": "Seelefackle",
  "block.minecraft.soul_wall_torch": "Seelewandfackle",
  "block.minecraft.spawn.not_valid": "Du hesch kei Bett und kein ufgladene Seeleanker, oder din Wiederiistigspunkt isch blockiert worde",
  "block.minecraft.spawner": "Spawner",
  "block.minecraft.spawner.desc1": "Benutz Spawn-Ei:",
  "block.minecraft.spawner.desc2": "Leit Kreaturetyp fest",
  "block.minecraft.sponge": "Schwamm",
  "block.minecraft.spore_blossom": "Sporeblüete",
  "block.minecraft.spruce_button": "Fichteholzchnopf",
  "block.minecraft.spruce_door": "Fichteholztür",
  "block.minecraft.spruce_fence": "Fichteholzhaag",
  "block.minecraft.spruce_fence_gate": "Fichteholzhaagtor",
  "block.minecraft.spruce_hanging_sign": "Fichteholzhängeschild",
  "block.minecraft.spruce_leaves": "Fichtenadle",
  "block.minecraft.spruce_log": "Fichtestamm",
  "block.minecraft.spruce_planks": "Fichteholzbretter",
  "block.minecraft.spruce_pressure_plate": "Fichteholzdruckplatte",
  "block.minecraft.spruce_sapling": "Fichtesetzling",
  "block.minecraft.spruce_shelf": "Fichteholzregal",
  "block.minecraft.spruce_sign": "Fichteholzschild",
  "block.minecraft.spruce_slab": "Fichteholzstufe",
  "block.minecraft.spruce_stairs": "Fichteholzstäge",
  "block.minecraft.spruce_trapdoor": "Fichteholzfalltür",
  "block.minecraft.spruce_wall_hanging_sign": "Fichteholzwandhängeschild",
  "block.minecraft.spruce_wall_sign": "Fichteholzwandschild",
  "block.minecraft.spruce_wood": "Fichteholz",
  "block.minecraft.sticky_piston": "Chlebrige Cholbe",
  "block.minecraft.stone": "Stei",
  "block.minecraft.stone_brick_slab": "Steiziegelstufe",
  "block.minecraft.stone_brick_stairs": "Steiziegelstäge",
  "block.minecraft.stone_brick_wall": "Steiziegelmur",
  "block.minecraft.stone_bricks": "Steiziegel",
  "block.minecraft.stone_button": "Steichnopf",
  "block.minecraft.stone_pressure_plate": "Steidruckplatte",
  "block.minecraft.stone_slab": "Steistufe",
  "block.minecraft.stone_stairs": "Steistäge",
  "block.minecraft.stonecutter": "Steisägi",
  "block.minecraft.stripped_acacia_log": "Entrindete Akaziestamm",
  "block.minecraft.stripped_acacia_wood": "Entrindets Akazieholz",
  "block.minecraft.stripped_bamboo_block": "Gschälte Bambusblock",
  "block.minecraft.stripped_birch_log": "Entrindete Birkestamm",
  "block.minecraft.stripped_birch_wood": "Entrindets Birkeholz",
  "block.minecraft.stripped_cherry_log": "Entrindete Chriesistamm",
  "block.minecraft.stripped_cherry_wood": "Entrindets Chriesiholz",
  "block.minecraft.stripped_crimson_hyphae": "Entrindete Karmesinhyphe",
  "block.minecraft.stripped_crimson_stem": "Entrindete Karmesinstamm",
  "block.minecraft.stripped_dark_oak_log": "Entrindete Schwarzeichestamm",
  "block.minecraft.stripped_dark_oak_wood": "Entrindets Schwarzeicheholz",
  "block.minecraft.stripped_jungle_log": "Entrindete Tropestamm",
  "block.minecraft.stripped_jungle_wood": "Entrindets Tropeholz",
  "block.minecraft.stripped_mangrove_log": "Entrindete Mangrovestamm",
  "block.minecraft.stripped_mangrove_wood": "Entrindets Mangroveholz",
  "block.minecraft.stripped_oak_log": "Entrindete Eichestamm",
  "block.minecraft.stripped_oak_wood": "Entrindets Eicheholz",
  "block.minecraft.stripped_pale_oak_log": "Entrindete Blasseichestamm",
  "block.minecraft.stripped_pale_oak_wood": "Entrindets Blasseicheholz",
  "block.minecraft.stripped_spruce_log": "Entrindete Fichtestamm",
  "block.minecraft.stripped_spruce_wood": "Entrindets Fichteholz",
  "block.minecraft.stripped_warped_hyphae": "Entrindete Wirrhyphe",
  "block.minecraft.stripped_warped_stem": "Entrindete Wirrstamm",
  "block.minecraft.structure_block": "Konstruktionsblock",
  "block.minecraft.structure_void": "Konstruktionsleeri",
  "block.minecraft.sugar_cane": "Zuckerrohr",
  "block.minecraft.sunflower": "Sunneblueme",
  "block.minecraft.suspicious_gravel": "Seltsame Chis",
  "block.minecraft.suspicious_sand": "Seltsame Sand",
  "block.minecraft.sweet_berry_bush": "Süessbeerestruch",
  "block.minecraft.tall_dry_grass": "Höchs Trockegras",
  "block.minecraft.tall_grass": "Höchs Gras",
  "block.minecraft.tall_seagrass": "Höchs Seegras",
  "block.minecraft.target": "Zielblock",
  "block.minecraft.terracotta": "Keramik",
  "block.minecraft.test_block": "Testblock",
  "block.minecraft.test_instance_block": "Testinstanzblock",
  "block.minecraft.tinted_glass": "Tönts Glas",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT‐Explosione sind deaktiviert",
  "block.minecraft.torch": "Fackle",
  "block.minecraft.torchflower": "Fackellilie",
  "block.minecraft.torchflower_crop": "Fackelliliepflanze",
  "block.minecraft.trapped_chest": "Redstone-Chiste",
  "block.minecraft.trial_spawner": "Prüefigs-Spawner",
  "block.minecraft.tripwire": "Stolperdroht",
  "block.minecraft.tripwire_hook": "Hoge",
  "block.minecraft.tube_coral": "Orgelkoralle",
  "block.minecraft.tube_coral_block": "Orgelkoralleblock",
  "block.minecraft.tube_coral_fan": "Orgelkorallefächer",
  "block.minecraft.tube_coral_wall_fan": "Orgelkorallewandfächer",
  "block.minecraft.tuff": "Tuffstei",
  "block.minecraft.tuff_brick_slab": "Tuffsteiziegelstufe",
  "block.minecraft.tuff_brick_stairs": "Tuffsteiziegelstäge",
  "block.minecraft.tuff_brick_wall": "Tuffsteiziegelmuur",
  "block.minecraft.tuff_bricks": "Tuffsteiziegel",
  "block.minecraft.tuff_slab": "Tuffsteistufe",
  "block.minecraft.tuff_stairs": "Tuffsteistäge",
  "block.minecraft.tuff_wall": "Tuffsteimuur",
  "block.minecraft.turtle_egg": "Schildchroteei",
  "block.minecraft.twisting_vines": "Zwirbelranke",
  "block.minecraft.twisting_vines_plant": "Zwirbelrankepflanze",
  "block.minecraft.vault": "Tresor",
  "block.minecraft.verdant_froglight": "Junggrüeni Froschlampe",
  "block.minecraft.vine": "Ranke",
  "block.minecraft.void_air": "Leerluft",
  "block.minecraft.wall_torch": "Wandfackle",
  "block.minecraft.warped_button": "Wirrholzchnopf",
  "block.minecraft.warped_door": "Wirrholztür",
  "block.minecraft.warped_fence": "Wirrholzhaag",
  "block.minecraft.warped_fence_gate": "Wirrholzhaagtor",
  "block.minecraft.warped_fungus": "Wirrpilz",
  "block.minecraft.warped_hanging_sign": "Wirrholzhängeschild",
  "block.minecraft.warped_hyphae": "Wirrhyphe",
  "block.minecraft.warped_nylium": "Wirr-Nezel",
  "block.minecraft.warped_planks": "Wirrholzbretter",
  "block.minecraft.warped_pressure_plate": "Wirrholzdruckplatte",
  "block.minecraft.warped_roots": "Wirrwurzle",
  "block.minecraft.warped_shelf": "Wirrholzregal",
  "block.minecraft.warped_sign": "Wirrholzschild",
  "block.minecraft.warped_slab": "Wirrholzstufe",
  "block.minecraft.warped_stairs": "Wirrholzstäge",
  "block.minecraft.warped_stem": "Wirrstil",
  "block.minecraft.warped_trapdoor": "Wirrholzfalltür",
  "block.minecraft.warped_wall_hanging_sign": "Wirrholzwandhängeschild",
  "block.minecraft.warped_wall_sign": "Wirrholzwandschild",
  "block.minecraft.warped_wart_block": "Wirrwarzeblock",
  "block.minecraft.water": "Wasser",
  "block.minecraft.water_cauldron": "Wasserchessel",
  "block.minecraft.waxed_chiseled_copper": "Gwachste gmeisslete Chupferblock",
  "block.minecraft.waxed_copper_bars": "Gwachsts Chupfergitter",
  "block.minecraft.waxed_copper_block": "Gwachste Chupferblock",
  "block.minecraft.waxed_copper_bulb": "Gwachsti Chupferlüchte",
  "block.minecraft.waxed_copper_chain": "Gwachsti Chupferchetti",
  "block.minecraft.waxed_copper_chest": "Gwachsti Chupferchiste",
  "block.minecraft.waxed_copper_door": "Gwachsti Chupfertür",
  "block.minecraft.waxed_copper_golem_statue": "Gwachsti Chupfergolemstatue",
  "block.minecraft.waxed_copper_grate": "Gwachsts Chupferrost",
  "block.minecraft.waxed_copper_lantern": "Gwachsti Chupferlaterne",
  "block.minecraft.waxed_copper_trapdoor": "Gwachsti Chupferfalltür",
  "block.minecraft.waxed_cut_copper": "Gwachste gschnittene Chupferblock",
  "block.minecraft.waxed_cut_copper_slab": "Gwachsti gschnitteni Chupferstufe",
  "block.minecraft.waxed_cut_copper_stairs": "Gwachsti gschnitteni Chupferstäge",
  "block.minecraft.waxed_exposed_chiseled_copper": "Gwachste agloffene gmeisslete Chupferblock",
  "block.minecraft.waxed_exposed_copper": "Gwachste agloffene Chupferblock",
  "block.minecraft.waxed_exposed_copper_bars": "Gwachsts agloffens Chupfergitter",
  "block.minecraft.waxed_exposed_copper_bulb": "Gwachsti agloffeni Chupferlüchte",
  "block.minecraft.waxed_exposed_copper_chain": "Gwachsti agloffeni Chupferchetti",
  "block.minecraft.waxed_exposed_copper_chest": "Gwachsti agloffeni Chupferchiste",
  "block.minecraft.waxed_exposed_copper_door": "Gwachsti agloffeni Chupfertür",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Gwachsti agloffeni Chupfergolemstatue",
  "block.minecraft.waxed_exposed_copper_grate": "Gwachsts agloffens Chupferrost",
  "block.minecraft.waxed_exposed_copper_lantern": "Gwachsti agloffeni Chupferlaterne",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Gwachsti agloffeni Chupferfalltür",
  "block.minecraft.waxed_exposed_cut_copper": "Gwachste agloffene gschnittene Chupferblock",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Gwachsti agloffeni gschnitteni Chupferstufe",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Gwachsti agloffeni gschnitteni Chupferstäge",
  "block.minecraft.waxed_exposed_lightning_rod": "Gwachste agloffene Blitzableiter",
  "block.minecraft.waxed_lightning_rod": "Gwachste Blitzableiter",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Gwachste oxidierte gmeisslete Chupferblock",
  "block.minecraft.waxed_oxidized_copper": "Gwachste aglaufene Chupferblock",
  "block.minecraft.waxed_oxidized_copper_bars": "Gwachsts oxidierts Chupfergitter",
  "block.minecraft.waxed_oxidized_copper_bulb": "Gwachsti oxidierti Chupferlüchti",
  "block.minecraft.waxed_oxidized_copper_chain": "Gwachsti oxidierti Chupferchetti",
  "block.minecraft.waxed_oxidized_copper_chest": "Gwachsti oxidierti Chupferchiste",
  "block.minecraft.waxed_oxidized_copper_door": "Gwachsti oxidierti Chupfertür",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Gwachsti oxidierti Chupfergolemstatue",
  "block.minecraft.waxed_oxidized_copper_grate": "Gwachsts oxidierts Chupferrost",
  "block.minecraft.waxed_oxidized_copper_lantern": "Gwachsti oxidierti Chupferlaterne",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Gwachsti oxidierti Chupferfalltür",
  "block.minecraft.waxed_oxidized_cut_copper": "Gwachste oxidierte gschnittene Chupferblock",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Gwachsti oxidierti gschnitteni Chupferstufe",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Gwachsti oxidierti gschnitteni Chupferstäge",
  "block.minecraft.waxed_oxidized_lightning_rod": "Gwachste oxidierte Blitzableiter",
  "block.minecraft.waxed_weathered_chiseled_copper": "Gwachste verwitterete gmeisslete Chupferblock",
  "block.minecraft.waxed_weathered_copper": "Gwachste verwitterete Chupferblock",
  "block.minecraft.waxed_weathered_copper_bars": "Gwachsts verwitterets Chupfergitter",
  "block.minecraft.waxed_weathered_copper_bulb": "Gwachsti verwittereti Chupferlüchte",
  "block.minecraft.waxed_weathered_copper_chain": "Gwachsti verwittereti Chupferchetti",
  "block.minecraft.waxed_weathered_copper_chest": "Gwachsti verwittereti Chupferchiste",
  "block.minecraft.waxed_weathered_copper_door": "Gwachsti verwitterti Chupfertür",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Gwachsti verwittereti Chupfergolemstatue",
  "block.minecraft.waxed_weathered_copper_grate": "Gwachsts verwitterts Chupferrost",
  "block.minecraft.waxed_weathered_copper_lantern": "Gwachsti verwittereti Chupferlaterne",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Gwachsti verwitterti Chupferfalltür",
  "block.minecraft.waxed_weathered_cut_copper": "Gwachste verwitterete gschnittene Chupferblock",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Gwachsti verwittereti gschnitteni Chupferstufe",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Gwachsti verwittereti gschnitteni Chupferstäge",
  "block.minecraft.waxed_weathered_lightning_rod": "Gwachste verwitterete Blitzableiter",
  "block.minecraft.weathered_chiseled_copper": "Verwitterte gmeisslete Chupferblock",
  "block.minecraft.weathered_copper": "Verwitterete Chupferblock",
  "block.minecraft.weathered_copper_bars": "Verwitterets Chupfergitter",
  "block.minecraft.weathered_copper_bulb": "Verwittereti Chupferlüchte",
  "block.minecraft.weathered_copper_chain": "Verwittereti Chupferchetti",
  "block.minecraft.weathered_copper_chest": "Verwittereti Chupferchiste",
  "block.minecraft.weathered_copper_door": "Verwitterti Chupfertür",
  "block.minecraft.weathered_copper_golem_statue": "Verwittereti Chupfergolemstatue",
  "block.minecraft.weathered_copper_grate": "Verwitterts Chupferrost",
  "block.minecraft.weathered_copper_lantern": "Verwittereti Chupferlaterne",
  "block.minecraft.weathered_copper_trapdoor": "Verwitterti Chupferfalltür",
  "block.minecraft.weathered_cut_copper": "Verwitterte gschnittene Chupferblock",
  "block.minecraft.weathered_cut_copper_slab": "Verwitterti gschnitteni Chupferstufe",
  "block.minecraft.weathered_cut_copper_stairs": "Verwitterti Chupferstäge",
  "block.minecraft.weathered_lightning_rod": "Verwitterete Blitzableiter",
  "block.minecraft.weeping_vines": "Trauerranke",
  "block.minecraft.weeping_vines_plant": "Trauerrankepflanze",
  "block.minecraft.wet_sponge": "Nasse Schwamm",
  "block.minecraft.wheat": "Weizepflanze",
  "block.minecraft.white_banner": "Wiisses Banner",
  "block.minecraft.white_bed": "Wiisses Bett",
  "block.minecraft.white_candle": "Wiissi Cherze",
  "block.minecraft.white_candle_cake": "Chueche mit wiisser Cherze",
  "block.minecraft.white_carpet": "Wiisse Teppich",
  "block.minecraft.white_concrete": "Wiisse Beton",
  "block.minecraft.white_concrete_powder": "Wiisse Trochebeton",
  "block.minecraft.white_glazed_terracotta": "Wiisse glasierte Keramik",
  "block.minecraft.white_shulker_box": "Wiissi Shulker-Chiste",
  "block.minecraft.white_stained_glass": "Wiisses Glas",
  "block.minecraft.white_stained_glass_pane": "Wiissi Glasschiibe",
  "block.minecraft.white_terracotta": "Wiisse Keramik",
  "block.minecraft.white_tulip": "Wiissi Tulpe",
  "block.minecraft.white_wool": "Wiissi Wulle",
  "block.minecraft.wildflowers": "Wildblueme",
  "block.minecraft.wither_rose": "Wither-Rose",
  "block.minecraft.wither_skeleton_skull": "Wither-Skelettschädel",
  "block.minecraft.wither_skeleton_wall_skull": "Wither-Skelett-Wandschädel",
  "block.minecraft.yellow_banner": "Gelbes Banner",
  "block.minecraft.yellow_bed": "Gelbes Bett",
  "block.minecraft.yellow_candle": "Gelbi Cherze",
  "block.minecraft.yellow_candle_cake": "Chueche mit gelber Cherze",
  "block.minecraft.yellow_carpet": "Gelbe Teppich",
  "block.minecraft.yellow_concrete": "Gelbe Beton",
  "block.minecraft.yellow_concrete_powder": "Gelbe Trochebeton",
  "block.minecraft.yellow_glazed_terracotta": "Gelbe glasierte Keramik",
  "block.minecraft.yellow_shulker_box": "Gelbi Shulkerchiste",
  "block.minecraft.yellow_stained_glass": "Gelbes Glas",
  "block.minecraft.yellow_stained_glass_pane": "Gelbi Glasschiibe",
  "block.minecraft.yellow_terracotta": "Gelbe Keramik",
  "block.minecraft.yellow_wool": "Gelbi Wulle",
  "block.minecraft.zombie_head": "Zombiechopf",
  "block.minecraft.zombie_wall_head": "Zombie-Wandchopf",
  "item.minecraft.acacia_boat": "Akazieholzboot",
  "item.minecraft.acacia_chest_boat": "Akazieholzchisteboot",
  "item.minecraft.allay_spawn_egg": "Hilfsgeist-Spawn-Ei",
  "item.minecraft.amethyst_shard": "Amethystscherbe",
  "item.minecraft.angler_pottery_shard": "Angler-Töpferscherbe",
  "item.minecraft.angler_pottery_sherd": "Angler-Töpferscherbe",
  "item.minecraft.apple": "Öpfel",
  "item.minecraft.archer_pottery_shard": "Schütze-Töpferscherbe",
  "item.minecraft.archer_pottery_sherd": "Schütze-Töpferscherbe",
  "item.minecraft.armadillo_scute": "Gürteltier-Hornschild",
  "item.minecraft.armadillo_spawn_egg": "Gürteltier-Spawn-Ei",
  "item.minecraft.armor_stand": "Rüstigsständer",
  "item.minecraft.arms_up_pottery_shard": "Gebärde-Töpferscherbe",
  "item.minecraft.arms_up_pottery_sherd": "Gebärde-Töpferscherbe",
  "item.minecraft.arrow": "Pfiil",
  "item.minecraft.axolotl_bucket": "Axolotlchübel",
  "item.minecraft.axolotl_spawn_egg": "Axolotl-Spawn-Ei",
  "item.minecraft.baked_potato": "Ofeherdöpfel",
  "item.minecraft.bamboo_chest_raft": "Bambus-Chistefloss",
  "item.minecraft.bamboo_raft": "Bambusfloss",
  "item.minecraft.bat_spawn_egg": "Fledermuus-Spawn-Ei",
  "item.minecraft.bee_spawn_egg": "Bienli-Spawn-Ei",
  "item.minecraft.beef": "Rohs Rindfleisch",
  "item.minecraft.beetroot": "Rande",
  "item.minecraft.beetroot_seeds": "Randesame",
  "item.minecraft.beetroot_soup": "Borschtsch",
  "item.minecraft.birch_boat": "Birkeholzboot",
  "item.minecraft.birch_chest_boat": "Birkeholzchisteboot",
  "item.minecraft.black_bundle": "Schwarzes Bündel",
  "item.minecraft.black_dye": "Schwarze Farbstoff",
  "item.minecraft.black_harness": "Schwarzes Gschirr",
  "item.minecraft.blade_pottery_shard": "Klinge-Töpferscherbe",
  "item.minecraft.blade_pottery_sherd": "Klinge-Töpferscherbe",
  "item.minecraft.blaze_powder": "Lohestaub",
  "item.minecraft.blaze_rod": "Loheruete",
  "item.minecraft.blaze_spawn_egg": "Lohe-Spawn-Ei",
  "item.minecraft.blue_bundle": "Blaus Bündel",
  "item.minecraft.blue_dye": "Blaue Farbstoff",
  "item.minecraft.blue_egg": "Blaus Ei",
  "item.minecraft.blue_harness": "Blaus Gschirr",
  "item.minecraft.bogged_spawn_egg": "Sumpfskelett-Spawn-Ei",
  "item.minecraft.bolt_armor_trim_smithing_template": "Schmiedvorlag",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolze-Rüstigsbesatz",
  "item.minecraft.bone": "Chnoche",
  "item.minecraft.bone_meal": "Chnochemehl",
  "item.minecraft.book": "Buech",
  "item.minecraft.bordure_indented_banner_pattern": "Spickelbord-Bannervorlag",
  "item.minecraft.bow": "Boge",
  "item.minecraft.bowl": "Schüssle",
  "item.minecraft.bread": "Brot",
  "item.minecraft.breeze_rod": "Böerute",
  "item.minecraft.breeze_spawn_egg": "Böe-Spawn-Ei",
  "item.minecraft.brewer_pottery_shard": "Brauer-Töpferscherbe",
  "item.minecraft.brewer_pottery_sherd": "Brauer-Töpferscherbe",
  "item.minecraft.brewing_stand": "Braustand",
  "item.minecraft.brick": "Ziegel",
  "item.minecraft.brown_bundle": "Bruuns Bündel",
  "item.minecraft.brown_dye": "Brune Farbstoff",
  "item.minecraft.brown_egg": "Bruns Ei",
  "item.minecraft.brown_harness": "Bruns Gschirr",
  "item.minecraft.brush": "Pinsel",
  "item.minecraft.bucket": "Chübel",
  "item.minecraft.bundle": "Bündel",
  "item.minecraft.bundle.empty": "Leer",
  "item.minecraft.bundle.empty.description": "Nimmt en gmischte Stapel Gegeständ uf",
  "item.minecraft.bundle.full": "Voll",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Flamme-Töpferscherbe",
  "item.minecraft.burn_pottery_sherd": "Flamme-Töpferscherbe",
  "item.minecraft.camel_husk_spawn_egg": "Zombiedromedar-Spawn-Ei",
  "item.minecraft.camel_spawn_egg": "Dromedar-Spawn-Ei",
  "item.minecraft.carrot": "Rüebli",
  "item.minecraft.carrot_on_a_stick": "Rüebliruete",
  "item.minecraft.cat_spawn_egg": "Chatze-Spawn-Ei",
  "item.minecraft.cauldron": "Chessel",
  "item.minecraft.cave_spider_spawn_egg": "Höhlespinne-Spawn-Ei",
  "item.minecraft.chainmail_boots": "Chettestiefel",
  "item.minecraft.chainmail_chestplate": "Chettehemd",
  "item.minecraft.chainmail_helmet": "Chettehelm",
  "item.minecraft.chainmail_leggings": "Chettehose",
  "item.minecraft.charcoal": "Holzchole",
  "item.minecraft.cherry_boat": "Chriesiholzboot",
  "item.minecraft.cherry_chest_boat": "Chriesiholzchisteboot",
  "item.minecraft.chest_minecart": "Güeterlore",
  "item.minecraft.chicken": "Rohs Huehn",
  "item.minecraft.chicken_spawn_egg": "Huehn-Spawn-Ei",
  "item.minecraft.chorus_fruit": "Chorusfrucht",
  "item.minecraft.clay_ball": "Tonchlumpe",
  "item.minecraft.clock": "Uhr",
  "item.minecraft.coal": "Steichole",
  "item.minecraft.coast_armor_trim_smithing_template": "Schmiedvorlag",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Chüste-Rüstigsbesatz",
  "item.minecraft.cocoa_beans": "Kakaobohne",
  "item.minecraft.cod": "Rohe Kabeljau",
  "item.minecraft.cod_bucket": "Kabeljauchübel",
  "item.minecraft.cod_spawn_egg": "Kabeljau-Spawn-Ei",
  "item.minecraft.command_block_minecart": "Befehlsblocklore",
  "item.minecraft.compass": "Kompass",
  "item.minecraft.cooked_beef": "Steak",
  "item.minecraft.cooked_chicken": "Brotens Huehn",
  "item.minecraft.cooked_cod": "Brotene Kabeljau",
  "item.minecraft.cooked_mutton": "Brotens Hammelfleisch",
  "item.minecraft.cooked_porkchop": "Brotens Schwiifleisch",
  "item.minecraft.cooked_rabbit": "Brotene Chüngel",
  "item.minecraft.cooked_salmon": "Brotene Lachs",
  "item.minecraft.cookie": "Guetzli",
  "item.minecraft.copper_axe": "Chupferaxt",
  "item.minecraft.copper_boots": "Chupferstiefel",
  "item.minecraft.copper_chestplate": "Chupferharnisch",
  "item.minecraft.copper_golem_spawn_egg": "Chupfergolem-Spawn-Ei",
  "item.minecraft.copper_helmet": "Chupferhelm",
  "item.minecraft.copper_hoe": "Chupferhacke",
  "item.minecraft.copper_horse_armor": "Chupfer-Rossharnisch",
  "item.minecraft.copper_ingot": "Chupferbarre",
  "item.minecraft.copper_leggings": "Chupferbeischutz",
  "item.minecraft.copper_nautilus_armor": "Chupfer-Nautiluspanzer",
  "item.minecraft.copper_nugget": "Chupferchlumpe",
  "item.minecraft.copper_pickaxe": "Chupferspitzhacke",
  "item.minecraft.copper_shovel": "Chupferschufle",
  "item.minecraft.copper_spear": "Chupferspeer",
  "item.minecraft.copper_sword": "Chupferschwert",
  "item.minecraft.cow_spawn_egg": "Chue-Spawn-Ei",
  "item.minecraft.creaking_spawn_egg": "Chnarz-Spawn-Ei",
  "item.minecraft.creeper_banner_pattern": "Bannervorlag",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Creeper-Bannervorlag",
  "item.minecraft.creeper_spawn_egg": "Creeper-Spawn-Ei",
  "item.minecraft.crossbow": "Armbrust",
  "item.minecraft.crossbow.projectile": "Gschoss:",
  "item.minecraft.crossbow.projectile.multiple": "Gschoss: %s× %s",
  "item.minecraft.crossbow.projectile.single": "Gschoss: %s",
  "item.minecraft.cyan_bundle": "Türkises Bündel",
  "item.minecraft.cyan_dye": "Türkise Farbstoff",
  "item.minecraft.cyan_harness": "Türkises Gschirr",
  "item.minecraft.danger_pottery_shard": "Gefahre-Töpferscherbe",
  "item.minecraft.danger_pottery_sherd": "Gefahre-Töpferscherbe",
  "item.minecraft.dark_oak_boat": "Schwarzeicheholzboot",
  "item.minecraft.dark_oak_chest_boat": "Schwarzeicheholzchisteboot",
  "item.minecraft.debug_stick": "Debug-Stab",
  "item.minecraft.debug_stick.empty": "%s het kei Blockzueständ",
  "item.minecraft.debug_stick.select": "«%s» usgwählt (%s)",
  "item.minecraft.debug_stick.update": "«%s» isch jetzt %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Diamantaxt",
  "item.minecraft.diamond_boots": "Diamantstiefel",
  "item.minecraft.diamond_chestplate": "Diamantharnisch",
  "item.minecraft.diamond_helmet": "Diamanthelm",
  "item.minecraft.diamond_hoe": "Diamantehacke",
  "item.minecraft.diamond_horse_armor": "Diamant-Rossharnisch",
  "item.minecraft.diamond_leggings": "Diamantbeischutz",
  "item.minecraft.diamond_nautilus_armor": "Diamant-Nautiluspanzer",
  "item.minecraft.diamond_pickaxe": "Diamantspitzhacke",
  "item.minecraft.diamond_shovel": "Diamantschufle",
  "item.minecraft.diamond_spear": "Diamantspeer",
  "item.minecraft.diamond_sword": "Diamantschwert",
  "item.minecraft.disc_fragment_5": "Plattebruchstück",
  "item.minecraft.disc_fragment_5.desc": "Schallplatte - 5",
  "item.minecraft.dolphin_spawn_egg": "Delfin-Spawn-Ei",
  "item.minecraft.donkey_spawn_egg": "Esel-Spawn-Ei",
  "item.minecraft.dragon_breath": "Dracheatem",
  "item.minecraft.dried_kelp": "Getröchnete Seetang",
  "item.minecraft.drowned_spawn_egg": "Ertrunkene-Spawn-Ei",
  "item.minecraft.dune_armor_trim_smithing_template": "Schmiedvorlag",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Düne-Rüstigsbesatz",
  "item.minecraft.echo_shard": "Echoscherbe",
  "item.minecraft.egg": "Ei",
  "item.minecraft.elder_guardian_spawn_egg": "Grosswächter-Spawn-Ei",
  "item.minecraft.elytra": "Elytre",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Verzauberts Buech",
  "item.minecraft.enchanted_golden_apple": "Verzauberte goldene Öpfel",
  "item.minecraft.end_crystal": "Enderkristall",
  "item.minecraft.ender_dragon_spawn_egg": "Enderdrache-Spawn-Ei",
  "item.minecraft.ender_eye": "Enderaug",
  "item.minecraft.ender_pearl": "Enderperle",
  "item.minecraft.enderman_spawn_egg": "Enderman-Spawn-Ei",
  "item.minecraft.endermite_spawn_egg": "Endermite-Spawn-Ei",
  "item.minecraft.evoker_spawn_egg": "Magier-Spawn-Ei",
  "item.minecraft.experience_bottle": "Erfahrigsfläschli",
  "item.minecraft.explorer_pottery_shard": "Entdecker-Töpferscherbe",
  "item.minecraft.explorer_pottery_sherd": "Entdecker-Töpferscherbe",
  "item.minecraft.eye_armor_trim_smithing_template": "Schmiedvorlag",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Auge-Rüstigsbesatz",
  "item.minecraft.feather": "Federe",
  "item.minecraft.fermented_spider_eye": "Fermentierts Spinnenaug",
  "item.minecraft.field_masoned_banner_pattern": "Muurig-Bannervorlag",
  "item.minecraft.filled_map": "Charte",
  "item.minecraft.fire_charge": "Füürchugle",
  "item.minecraft.firework_rocket": "Füürwerksragete",
  "item.minecraft.firework_rocket.flight": "Flugduur:",
  "item.minecraft.firework_rocket.multiple_stars": "%s× %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Füürwerksstern",
  "item.minecraft.firework_star.black": "Schwarz",
  "item.minecraft.firework_star.blue": "Blau",
  "item.minecraft.firework_star.brown": "Brun",
  "item.minecraft.firework_star.custom_color": "Benutzerdefiniert",
  "item.minecraft.firework_star.cyan": "Türkis",
  "item.minecraft.firework_star.fade_to": "Übergang zu",
  "item.minecraft.firework_star.flicker": "Funkle",
  "item.minecraft.firework_star.gray": "Grau",
  "item.minecraft.firework_star.green": "Grüen",
  "item.minecraft.firework_star.light_blue": "Hellblau",
  "item.minecraft.firework_star.light_gray": "Hellgrau",
  "item.minecraft.firework_star.lime": "Hellgrüen",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Orange",
  "item.minecraft.firework_star.pink": "Rosa",
  "item.minecraft.firework_star.purple": "Violett",
  "item.minecraft.firework_star.red": "Rot",
  "item.minecraft.firework_star.shape": "Unbekannti Form",
  "item.minecraft.firework_star.shape.burst": "Explosion",
  "item.minecraft.firework_star.shape.creeper": "Creeperförmig",
  "item.minecraft.firework_star.shape.large_ball": "Grossi Chugle",
  "item.minecraft.firework_star.shape.small_ball": "Chliini Chugle",
  "item.minecraft.firework_star.shape.star": "Sternförmig",
  "item.minecraft.firework_star.trail": "Schweif",
  "item.minecraft.firework_star.white": "Wiiss",
  "item.minecraft.firework_star.yellow": "Gelb",
  "item.minecraft.fishing_rod": "Angle",
  "item.minecraft.flint": "Füürstei",
  "item.minecraft.flint_and_steel": "Füürzüg",
  "item.minecraft.flow_armor_trim_smithing_template": "Schmiedvorlag",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Fluss-Rüstigsbesatz",
  "item.minecraft.flow_banner_pattern": "Bannervorlag",
  "item.minecraft.flow_banner_pattern.desc": "Fluss",
  "item.minecraft.flow_banner_pattern.new": "Fluss-Bannervorlag",
  "item.minecraft.flow_pottery_sherd": "Fluss-Töpferscherbe",
  "item.minecraft.flower_banner_pattern": "Bannervorlag",
  "item.minecraft.flower_banner_pattern.desc": "Blueme",
  "item.minecraft.flower_banner_pattern.new": "Blueme-Bannervorlag",
  "item.minecraft.flower_pot": "Bluemetopf",
  "item.minecraft.fox_spawn_egg": "Fuchs-Spawn-Ei",
  "item.minecraft.friend_pottery_shard": "Fründes-Töpferscherbe",
  "item.minecraft.friend_pottery_sherd": "Fründes-Töpferscherbe",
  "item.minecraft.frog_spawn_egg": "Frosch-Spawn-Ei",
  "item.minecraft.furnace_minecart": "Atriebslore",
  "item.minecraft.ghast_spawn_egg": "Ghast-Spawn-Ei",
  "item.minecraft.ghast_tear": "Ghastträne",
  "item.minecraft.glass_bottle": "Glasfläsche",
  "item.minecraft.glistering_melon_slice": "Glitzerndi Meloneschibe",
  "item.minecraft.globe_banner_pattern": "Bannervorlag",
  "item.minecraft.globe_banner_pattern.desc": "Globus",
  "item.minecraft.globe_banner_pattern.new": "Globus-Bannervorlag",
  "item.minecraft.glow_berries": "Lüchtbeere",
  "item.minecraft.glow_ink_sac": "Lüchttintebütel",
  "item.minecraft.glow_item_frame": "Lüchtrahme",
  "item.minecraft.glow_squid_spawn_egg": "Lüchttintefisch-Spawn-Ei",
  "item.minecraft.glowstone_dust": "Lüchtsteistaub",
  "item.minecraft.goat_horn": "Geissehorn",
  "item.minecraft.goat_spawn_egg": "Geiss-Spawn-Ei",
  "item.minecraft.gold_ingot": "Goldbarre",
  "item.minecraft.gold_nugget": "Goldchlumpe",
  "item.minecraft.golden_apple": "Goldene Öpfel",
  "item.minecraft.golden_axe": "Goldaxt",
  "item.minecraft.golden_boots": "Goldstiefel",
  "item.minecraft.golden_carrot": "Goldenes Rüebli",
  "item.minecraft.golden_chestplate": "Goldharnisch",
  "item.minecraft.golden_helmet": "Goldhelm",
  "item.minecraft.golden_hoe": "Goldhacke",
  "item.minecraft.golden_horse_armor": "Gold-Rossharnisch",
  "item.minecraft.golden_leggings": "Goldbeischutz",
  "item.minecraft.golden_nautilus_armor": "Gold-Nautiluspanzer",
  "item.minecraft.golden_pickaxe": "Goldspitzhacke",
  "item.minecraft.golden_shovel": "Goldschufle",
  "item.minecraft.golden_spear": "Goldspeer",
  "item.minecraft.golden_sword": "Goldschwert",
  "item.minecraft.gray_bundle": "Graus Bündel",
  "item.minecraft.gray_dye": "Graue Farbstoff",
  "item.minecraft.gray_harness": "Graus Gschirr",
  "item.minecraft.green_bundle": "Grüens Bündel",
  "item.minecraft.green_dye": "Grüene Farbstoff",
  "item.minecraft.green_harness": "Grüens Gschirr",
  "item.minecraft.guardian_spawn_egg": "Wächter-Spawn-Ei",
  "item.minecraft.gunpowder": "Schwarzpulver",
  "item.minecraft.guster_banner_pattern": "Bannervorlag",
  "item.minecraft.guster_banner_pattern.desc": "Windstosser",
  "item.minecraft.guster_banner_pattern.new": "Windstosser-Bannervorlag",
  "item.minecraft.guster_pottery_sherd": "Windstosser-Töpferscherbe",
  "item.minecraft.happy_ghast_spawn_egg": "Glückliche-Ghast-Spawn-Ei",
  "item.minecraft.harness": "Gschirr",
  "item.minecraft.heart_of_the_sea": "Herz vom Meer",
  "item.minecraft.heart_pottery_shard": "Herz-Töpferscherbe",
  "item.minecraft.heart_pottery_sherd": "Herz-Töpferscherbe",
  "item.minecraft.heartbreak_pottery_shard": "Herzschmerz-Töpferscherbe",
  "item.minecraft.heartbreak_pottery_sherd": "Herzschmerz-Töpferscherbe",
  "item.minecraft.hoglin_spawn_egg": "Hoglin-Spawn-Ei",
  "item.minecraft.honey_bottle": "Honigfläsche",
  "item.minecraft.honeycomb": "Honigwabe",
  "item.minecraft.hopper_minecart": "Trichterlore",
  "item.minecraft.horse_spawn_egg": "Ross-Spawn-Ei",
  "item.minecraft.host_armor_trim_smithing_template": "Schmiedvorlag",
  "item.minecraft.host_armor_trim_smithing_template.new": "Gastwirts-Rüstigsbesatz",
  "item.minecraft.howl_pottery_shard": "Gehüle-Töpferscherbe",
  "item.minecraft.howl_pottery_sherd": "Gehüle-Töpferscherbe",
  "item.minecraft.husk_spawn_egg": "Wüestezombie-Spawn-Ei",
  "item.minecraft.ink_sac": "Tintebütel",
  "item.minecraft.iron_axe": "Iiseaxt",
  "item.minecraft.iron_boots": "Iisestiefel",
  "item.minecraft.iron_chestplate": "Iiseharnisch",
  "item.minecraft.iron_golem_spawn_egg": "Iisegolem-Spawn-Ei",
  "item.minecraft.iron_helmet": "Iisehelm",
  "item.minecraft.iron_hoe": "Iisehacke",
  "item.minecraft.iron_horse_armor": "Iise-Rossharnisch",
  "item.minecraft.iron_ingot": "Iisebarre",
  "item.minecraft.iron_leggings": "Iisebeischutz",
  "item.minecraft.iron_nautilus_armor": "Iise-Nautiluspanzer",
  "item.minecraft.iron_nugget": "Iisechlumpe",
  "item.minecraft.iron_pickaxe": "Iisespitzhacke",
  "item.minecraft.iron_shovel": "Iiseschufle",
  "item.minecraft.iron_spear": "Iisespeer",
  "item.minecraft.iron_sword": "Iiseschwert",
  "item.minecraft.item_frame": "Rahme",
  "item.minecraft.jungle_boat": "Tropeholzboot",
  "item.minecraft.jungle_chest_boat": "Tropeholzchisteboot",
  "item.minecraft.knowledge_book": "Buch des Wüssens",
  "item.minecraft.lapis_lazuli": "Lapislazuli",
  "item.minecraft.lava_bucket": "Lavachübel",
  "item.minecraft.lead": "Leine",
  "item.minecraft.leather": "Leder",
  "item.minecraft.leather_boots": "Lederstiefel",
  "item.minecraft.leather_chestplate": "Lederjacke",
  "item.minecraft.leather_helmet": "Lederchappe",
  "item.minecraft.leather_horse_armor": "Leder-Rossharnisch",
  "item.minecraft.leather_leggings": "Lederhose",
  "item.minecraft.light_blue_bundle": "Hellblaus Bündel",
  "item.minecraft.light_blue_dye": "Hellblaue Farbstoff",
  "item.minecraft.light_blue_harness": "Hellblaus Gschirr",
  "item.minecraft.light_gray_bundle": "Hellgraus Bündel",
  "item.minecraft.light_gray_dye": "Hellgraue Farbstoff",
  "item.minecraft.light_gray_harness": "Hellgraus Gschirr",
  "item.minecraft.lime_bundle": "Hellgrüens Bündel",
  "item.minecraft.lime_dye": "Hellgrüene Farbstoff",
  "item.minecraft.lime_harness": "Hellgrüens Gschirr",
  "item.minecraft.lingering_potion": "Verwiiltrank",
  "item.minecraft.lingering_potion.effect.awkward": "Seltsame Verwiiltrank",
  "item.minecraft.lingering_potion.effect.empty": "Nöd braubare Verwiiltrank",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Verwiiltrank vode Füürresistenz",
  "item.minecraft.lingering_potion.effect.harming": "Verwiiltrank vom Schade",
  "item.minecraft.lingering_potion.effect.healing": "Verwiiltrank vode Heilig",
  "item.minecraft.lingering_potion.effect.infested": "Verwiiltrank vom Befall",
  "item.minecraft.lingering_potion.effect.invisibility": "Verwiiltrank vode Unsichtbarkeit",
  "item.minecraft.lingering_potion.effect.leaping": "Verwiiltrank vode Sprungchraft",
  "item.minecraft.lingering_potion.effect.levitation": "Verwiiltrank vode Schwebechraft",
  "item.minecraft.lingering_potion.effect.luck": "Verwiiltrank vom Glück",
  "item.minecraft.lingering_potion.effect.mundane": "Gwöhnliche Verwiiltrank",
  "item.minecraft.lingering_potion.effect.night_vision": "Verwiiltrank vode Nachtsicht",
  "item.minecraft.lingering_potion.effect.oozing": "Verwiiltrank vom Schliime",
  "item.minecraft.lingering_potion.effect.poison": "Verwiiltrank vode Vergiftig",
  "item.minecraft.lingering_potion.effect.regeneration": "Verwiiltrank vode Regeneration",
  "item.minecraft.lingering_potion.effect.slow_falling": "Verwiiltrank vom sanfte Fall",
  "item.minecraft.lingering_potion.effect.slowness": "Verwiiltrank vode Langsamkeit",
  "item.minecraft.lingering_potion.effect.strength": "Verwiiltrank vode Stärki",
  "item.minecraft.lingering_potion.effect.swiftness": "Verwiiltrank vode Schnelligkeit",
  "item.minecraft.lingering_potion.effect.thick": "Dickflüssige Verwiiltrank",
  "item.minecraft.lingering_potion.effect.turtle_master": "Verwiiltrank vom Schildchrotemeister",
  "item.minecraft.lingering_potion.effect.water": "Verwiilendi Wasserfläsche",
  "item.minecraft.lingering_potion.effect.water_breathing": "Verwiiltrank vode Unterwasseratmig",
  "item.minecraft.lingering_potion.effect.weakness": "Verwiiltrank vode Schwächi",
  "item.minecraft.lingering_potion.effect.weaving": "Verwiiltrank vom Webe",
  "item.minecraft.lingering_potion.effect.wind_charged": "Verwiiltrank vode Windladig",
  "item.minecraft.llama_spawn_egg": "Lama-Spawn-Ei",
  "item.minecraft.lodestone_compass": "Leitstei-Kompass",
  "item.minecraft.mace": "Striitcholbe",
  "item.minecraft.magenta_bundle": "Magenta Bündel",
  "item.minecraft.magenta_dye": "Magenta Farbstoff",
  "item.minecraft.magenta_harness": "Magenta Gschirr",
  "item.minecraft.magma_cream": "Magmacreme",
  "item.minecraft.magma_cube_spawn_egg": "Magmawürfel-Spawn-Ei",
  "item.minecraft.mangrove_boat": "Mangroveholzboot",
  "item.minecraft.mangrove_chest_boat": "Mangroveholzchisteboot",
  "item.minecraft.map": "Leeri Charte",
  "item.minecraft.melon_seeds": "Melonecherne",
  "item.minecraft.melon_slice": "Meloneschibe",
  "item.minecraft.milk_bucket": "Milchchübel",
  "item.minecraft.minecart": "Lore",
  "item.minecraft.miner_pottery_shard": "Bergarbeiter-Töpferscherbe",
  "item.minecraft.miner_pottery_sherd": "Bergarbeiter-Töpferscherbe",
  "item.minecraft.mojang_banner_pattern": "Bannervorlag",
  "item.minecraft.mojang_banner_pattern.desc": "Mojang-Logo",
  "item.minecraft.mojang_banner_pattern.new": "Mojang-Logo-Bannervorlag",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroom-Spawn-Ei",
  "item.minecraft.mourner_pottery_shard": "Wimmerer-Töpferscherbe",
  "item.minecraft.mourner_pottery_sherd": "Wimmerer-Töpferscherbe",
  "item.minecraft.mule_spawn_egg": "Muultier-Spawn-Ei",
  "item.minecraft.mushroom_stew": "Pilzsuppe",
  "item.minecraft.music_disc_11": "Schallplatte",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Schallplatte",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Schallplatte",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Schallplatte",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Schallplatte",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Schallplatte",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Schallplatte",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Schallplatte",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Schallplatte",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Schallplatte",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Schallplatte",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Schallplatte",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Schallplatte",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Schallplatte",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Schallplatte",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Schallplatte",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Schallplatte",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Schallplatte",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Schallplatte",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Schallplatte",
  "item.minecraft.music_disc_wait.desc": "C418 - Wait",
  "item.minecraft.music_disc_ward": "Schallplatte",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Rohs Hammelfleisch",
  "item.minecraft.name_tag": "Namensschild",
  "item.minecraft.nautilus_shell": "Nautilusschale",
  "item.minecraft.nautilus_spawn_egg": "Nautilus-Spawn-Ei",
  "item.minecraft.nether_brick": "Netherziegel",
  "item.minecraft.nether_star": "Netherstern",
  "item.minecraft.nether_wart": "Netherwarze",
  "item.minecraft.netherite_axe": "Netheritaxt",
  "item.minecraft.netherite_boots": "Netheritstiefel",
  "item.minecraft.netherite_chestplate": "Netheritharnisch",
  "item.minecraft.netherite_helmet": "Netherithelm",
  "item.minecraft.netherite_hoe": "Netherithacke",
  "item.minecraft.netherite_horse_armor": "Netherit-Nautiluspanzer",
  "item.minecraft.netherite_ingot": "Netheritbarre",
  "item.minecraft.netherite_leggings": "Netheritbeischutz",
  "item.minecraft.netherite_nautilus_armor": "Netherit-Nautiluspanzer",
  "item.minecraft.netherite_pickaxe": "Netheritspitzhacke",
  "item.minecraft.netherite_scrap": "Netheritplatte",
  "item.minecraft.netherite_shovel": "Netheritschufle",
  "item.minecraft.netherite_spear": "Netheritspeer",
  "item.minecraft.netherite_sword": "Netheritschwert",
  "item.minecraft.netherite_upgrade_smithing_template": "Schmiedvorlag",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netheritufwertig",
  "item.minecraft.oak_boat": "Eicheholzboot",
  "item.minecraft.oak_chest_boat": "Eicheholzchisteboot",
  "item.minecraft.ocelot_spawn_egg": "Ozelot-Spawn-Ei",
  "item.minecraft.ominous_bottle": "Unheilvolli Fläsche",
  "item.minecraft.ominous_trial_key": "Unheilvolle Prüefigsschlüssel",
  "item.minecraft.orange_bundle": "Oranges Bündel",
  "item.minecraft.orange_dye": "Orange Farbstoff",
  "item.minecraft.orange_harness": "Oranges Gschirr",
  "item.minecraft.painting": "Gmäld",
  "item.minecraft.pale_oak_boat": "Blasseicheholzboot",
  "item.minecraft.pale_oak_chest_boat": "Blasseicheholzchisteboot",
  "item.minecraft.panda_spawn_egg": "Panda-Spawn-Ei",
  "item.minecraft.paper": "Papier",
  "item.minecraft.parched_spawn_egg": "Vertröchneter-Spawn-Ei",
  "item.minecraft.parrot_spawn_egg": "Papagei-Spawn-Ei",
  "item.minecraft.phantom_membrane": "Phantomhuut",
  "item.minecraft.phantom_spawn_egg": "Phantom-Spawn-Ei",
  "item.minecraft.pig_spawn_egg": "Schwii-Spawn-Ei",
  "item.minecraft.piglin_banner_pattern": "Bannervorlag",
  "item.minecraft.piglin_banner_pattern.desc": "Schnauze",
  "item.minecraft.piglin_banner_pattern.new": "Schnauze-Bannervorlag",
  "item.minecraft.piglin_brute_spawn_egg": "Piglin-Barbar-Spawn-Ei",
  "item.minecraft.piglin_spawn_egg": "Piglin-Spawn-Ei",
  "item.minecraft.pillager_spawn_egg": "Plünderer-Spawn-Ei",
  "item.minecraft.pink_bundle": "Rosa Bündel",
  "item.minecraft.pink_dye": "Rosa Farbstoff",
  "item.minecraft.pink_harness": "Rosa Gschirr",
  "item.minecraft.pitcher_plant": "Channepflanze",
  "item.minecraft.pitcher_pod": "Channepflanzekapsel",
  "item.minecraft.plenty_pottery_shard": "Richtums-Töpferscherbe",
  "item.minecraft.plenty_pottery_sherd": "Richtums-Töpferscherbe",
  "item.minecraft.poisonous_potato": "Giftige Herdöpfel",
  "item.minecraft.polar_bear_spawn_egg": "Iisbär-Spawn-Ei",
  "item.minecraft.popped_chorus_fruit": "Platzti Chorusfrucht",
  "item.minecraft.porkchop": "Rohs Schwiifleisch",
  "item.minecraft.potato": "Herdöpfel",
  "item.minecraft.potion": "Trank",
  "item.minecraft.potion.effect.awkward": "Seltsame Trank",
  "item.minecraft.potion.effect.empty": "Nöd braubare Trank",
  "item.minecraft.potion.effect.fire_resistance": "Trank vode Füürresistenz",
  "item.minecraft.potion.effect.harming": "Trank vom Schade",
  "item.minecraft.potion.effect.healing": "Trank vode Heilig",
  "item.minecraft.potion.effect.infested": "Trank vom Befall",
  "item.minecraft.potion.effect.invisibility": "Trank vode Unsichtbarkeit",
  "item.minecraft.potion.effect.leaping": "Trank vode Sprungchraft",
  "item.minecraft.potion.effect.levitation": "Trank vode Schwebechraft",
  "item.minecraft.potion.effect.luck": "Trank vom Glück",
  "item.minecraft.potion.effect.mundane": "Gwöhnliche Trank",
  "item.minecraft.potion.effect.night_vision": "Trank vode Nachtsicht",
  "item.minecraft.potion.effect.oozing": "Trank vom Schliime",
  "item.minecraft.potion.effect.poison": "Trank vode Vergiftig",
  "item.minecraft.potion.effect.regeneration": "Trank vode Regeneration",
  "item.minecraft.potion.effect.slow_falling": "Trank vom sanfte Fall",
  "item.minecraft.potion.effect.slowness": "Trank vode Langsamkeit",
  "item.minecraft.potion.effect.strength": "Trank vode Stärki",
  "item.minecraft.potion.effect.swiftness": "Trank vode Schnelligkeit",
  "item.minecraft.potion.effect.thick": "Dickflüssige Trank",
  "item.minecraft.potion.effect.turtle_master": "Trank vom Schildchrotemeister",
  "item.minecraft.potion.effect.water": "Wasserfläsche",
  "item.minecraft.potion.effect.water_breathing": "Trank vode Unterwasseratmig",
  "item.minecraft.potion.effect.weakness": "Trank vode Schwächi",
  "item.minecraft.potion.effect.weaving": "Trank vom Webe",
  "item.minecraft.potion.effect.wind_charged": "Trank vode Windladig",
  "item.minecraft.pottery_shard_archer": "Schütze-Töpferscherbe",
  "item.minecraft.pottery_shard_arms_up": "Gebärde-Töpferscherbe",
  "item.minecraft.pottery_shard_prize": "Juwele-Töpferscherbe",
  "item.minecraft.pottery_shard_skull": "Totechopf-Töpferscherbe",
  "item.minecraft.powder_snow_bucket": "Pulverschneechübel",
  "item.minecraft.prismarine_crystals": "Prismarinkristall",
  "item.minecraft.prismarine_shard": "Prismarinscherbe",
  "item.minecraft.prize_pottery_shard": "Juwele-Töpferscherbe",
  "item.minecraft.prize_pottery_sherd": "Juwele-Töpferscherbe",
  "item.minecraft.pufferfish": "Chugelfisch",
  "item.minecraft.pufferfish_bucket": "Chugelfischchübel",
  "item.minecraft.pufferfish_spawn_egg": "Chugelfisch-Spawn-Ei",
  "item.minecraft.pumpkin_pie": "Chürbischueche",
  "item.minecraft.pumpkin_seeds": "Chürbischerne",
  "item.minecraft.purple_bundle": "Violetts Bündel",
  "item.minecraft.purple_dye": "Violette Farbstoff",
  "item.minecraft.purple_harness": "Violetts Gschirr",
  "item.minecraft.quartz": "Netherquarz",
  "item.minecraft.rabbit": "Rohe Chüngel",
  "item.minecraft.rabbit_foot": "Chüngelpfote",
  "item.minecraft.rabbit_hide": "Chüngelfell",
  "item.minecraft.rabbit_spawn_egg": "Chüngel-Spawn-Ei",
  "item.minecraft.rabbit_stew": "Chüngelragout",
  "item.minecraft.raiser_armor_trim_smithing_template": "Schmiedvorlag",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Ufzieher-Rüstigsbesatz",
  "item.minecraft.ravager_spawn_egg": "Verwüester-Spawn-Ei",
  "item.minecraft.raw_copper": "Rohchupfer",
  "item.minecraft.raw_gold": "Rohgold",
  "item.minecraft.raw_iron": "Rohiise",
  "item.minecraft.recovery_compass": "Rettigskompass",
  "item.minecraft.red_bundle": "Rots Bündel",
  "item.minecraft.red_dye": "Rote Farbstoff",
  "item.minecraft.red_harness": "Rots Gschirr",
  "item.minecraft.redstone": "Redstone-Staub",
  "item.minecraft.resin_brick": "Harzziegel",
  "item.minecraft.resin_clump": "Harzchlumpe",
  "item.minecraft.rib_armor_trim_smithing_template": "Schmiedvorlag",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rippe-Rüstigsbesatz",
  "item.minecraft.rotten_flesh": "Verrottets Fleisch",
  "item.minecraft.saddle": "Sattel",
  "item.minecraft.salmon": "Rohe Lachs",
  "item.minecraft.salmon_bucket": "Lachschübel",
  "item.minecraft.salmon_spawn_egg": "Lachs-Spawn-Ei",
  "item.minecraft.scrape_pottery_sherd": "Abschabe-Töpferscherbe",
  "item.minecraft.scute": "Hornschild",
  "item.minecraft.sentry_armor_trim_smithing_template": "Schmiedvorlag",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Wache-Rüstigsbesatz",
  "item.minecraft.shaper_armor_trim_smithing_template": "Schmiedvorlag",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Gstalter-Rüstigsbesatz",
  "item.minecraft.sheaf_pottery_shard": "Garbe-Töpferscherbe",
  "item.minecraft.sheaf_pottery_sherd": "Garbe-Töpferscherbe",
  "item.minecraft.shears": "Schär",
  "item.minecraft.sheep_spawn_egg": "Schaf-Spawn-Ei",
  "item.minecraft.shelter_pottery_shard": "Zuefluchts-Töpferscherbe",
  "item.minecraft.shelter_pottery_sherd": "Zuefluchts-Töpferscherbe",
  "item.minecraft.shield": "Schild",
  "item.minecraft.shield.black": "Schwarzes Schild",
  "item.minecraft.shield.blue": "Blaus Schild",
  "item.minecraft.shield.brown": "Bruns Schild",
  "item.minecraft.shield.cyan": "Türkises Schild",
  "item.minecraft.shield.gray": "Graus Schild",
  "item.minecraft.shield.green": "Grüens Schild",
  "item.minecraft.shield.light_blue": "Hellblaus Schild",
  "item.minecraft.shield.light_gray": "Hellgraus Schild",
  "item.minecraft.shield.lime": "Hellgrüens Schild",
  "item.minecraft.shield.magenta": "Magenta Schild",
  "item.minecraft.shield.orange": "Oranges Schild",
  "item.minecraft.shield.pink": "Rosa Schild",
  "item.minecraft.shield.purple": "Violetts Schild",
  "item.minecraft.shield.red": "Rots Schild",
  "item.minecraft.shield.white": "Wiisses Schild",
  "item.minecraft.shield.yellow": "Gelbes Schild",
  "item.minecraft.shulker_shell": "Shulker-Schale",
  "item.minecraft.shulker_spawn_egg": "Shulker-Spawn-Ei",
  "item.minecraft.sign": "Schild",
  "item.minecraft.silence_armor_trim_smithing_template": "Schmiedvorlag",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Stille-Rüstigsbesatz",
  "item.minecraft.silverfish_spawn_egg": "Silberfischli-Spawn-Ei",
  "item.minecraft.skeleton_horse_spawn_egg": "Skelettross-Spawn-Ei",
  "item.minecraft.skeleton_spawn_egg": "Skelett-Spawn-Ei",
  "item.minecraft.skull_banner_pattern": "Bannervorlag",
  "item.minecraft.skull_banner_pattern.desc": "Schädel",
  "item.minecraft.skull_banner_pattern.new": "Schädel-Bannervorlag",
  "item.minecraft.skull_pottery_shard": "Totechopf-Töpferscherbe",
  "item.minecraft.skull_pottery_sherd": "Totechopf-Töpferscherbe",
  "item.minecraft.slime_ball": "Schliimball",
  "item.minecraft.slime_spawn_egg": "Schliim-Spawn-Ei",
  "item.minecraft.smithing_template": "Schmiedvorlag",
  "item.minecraft.smithing_template.applies_to": "Awendbar uf:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Barre oder Kristall hinzuefüege",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Rüstig",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Rüstigsteil hinzuefüege",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Barre & Kristall",
  "item.minecraft.smithing_template.ingredients": "Werkstoff:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Netheritbarre hinzuefüege",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamatusrüstig",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Rüstigsteil, Werkzüg oder Schwert us Diamant hinzuefüege",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netheritbarre",
  "item.minecraft.smithing_template.upgrade": "Ufwertig: ",
  "item.minecraft.sniffer_spawn_egg": "Schnüffler-Spawn-Ei",
  "item.minecraft.snort_pottery_shard": "Schnaub-Töpferscherbe",
  "item.minecraft.snort_pottery_sherd": "Schnaub-Töpferscherbe",
  "item.minecraft.snout_armor_trim_smithing_template": "Schmiedvorlag",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Schnauze-Rüstigsbesatz",
  "item.minecraft.snow_golem_spawn_egg": "Schneegolem-Spawn-Ei",
  "item.minecraft.snowball": "Schneeball",
  "item.minecraft.spectral_arrow": "Spektralpfil",
  "item.minecraft.spider_eye": "Spinnenaug",
  "item.minecraft.spider_spawn_egg": "Spinne-Spawn-Ei",
  "item.minecraft.spire_armor_trim_smithing_template": "Schmiedvorlag",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Turmspitze-Rüstigsbesatz",
  "item.minecraft.splash_potion": "Wurftrank",
  "item.minecraft.splash_potion.effect.awkward": "Seltsame Wurftrank",
  "item.minecraft.splash_potion.effect.empty": "Nöd braubare Wurftrank",
  "item.minecraft.splash_potion.effect.fire_resistance": "Wurftrank vode Füürresistenz",
  "item.minecraft.splash_potion.effect.harming": "Wurftrank vom Schade",
  "item.minecraft.splash_potion.effect.healing": "Wurftrank vode Heilig",
  "item.minecraft.splash_potion.effect.infested": "Wurftrank vom Befall",
  "item.minecraft.splash_potion.effect.invisibility": "Wurftrank vode Unsichtbarkeit",
  "item.minecraft.splash_potion.effect.leaping": "Wurftrank vode Sprungchraft",
  "item.minecraft.splash_potion.effect.levitation": "Wurftrank vode Schwebechraft",
  "item.minecraft.splash_potion.effect.luck": "Wurftrank vom Glück",
  "item.minecraft.splash_potion.effect.mundane": "Normale Wurftrank",
  "item.minecraft.splash_potion.effect.night_vision": "Wurftrank vode Nachtsicht",
  "item.minecraft.splash_potion.effect.oozing": "Wurftrank vom Schliime",
  "item.minecraft.splash_potion.effect.poison": "Wurftrank vode Vergiftig",
  "item.minecraft.splash_potion.effect.regeneration": "Wurftrank vode Regeneration",
  "item.minecraft.splash_potion.effect.slow_falling": "Wurftrank vom sanfte Fall",
  "item.minecraft.splash_potion.effect.slowness": "Wurftrank vode Langsamkeit",
  "item.minecraft.splash_potion.effect.strength": "Wurftrank vode Stärki",
  "item.minecraft.splash_potion.effect.swiftness": "Wurftrank vode Schnelligkeit",
  "item.minecraft.splash_potion.effect.thick": "Dickflüssige Wurftank",
  "item.minecraft.splash_potion.effect.turtle_master": "Wurftrank vom Schildchrotemeister",
  "item.minecraft.splash_potion.effect.water": "Werfbari Wasserfläsche",
  "item.minecraft.splash_potion.effect.water_breathing": "Wurftrank vode Unterwasseratmig",
  "item.minecraft.splash_potion.effect.weakness": "Wurftrank vode Schwächi",
  "item.minecraft.splash_potion.effect.weaving": "Wurftrank vom Webe",
  "item.minecraft.splash_potion.effect.wind_charged": "Wurftrank vode Windladig",
  "item.minecraft.spruce_boat": "Fichteholzboot",
  "item.minecraft.spruce_chest_boat": "Fichteholzchisteboot",
  "item.minecraft.spyglass": "Fernrohr",
  "item.minecraft.squid_spawn_egg": "Tintefisch-Spawn-Ei",
  "item.minecraft.stick": "Stock",
  "item.minecraft.stone_axe": "Steiaxt",
  "item.minecraft.stone_hoe": "Steihacke",
  "item.minecraft.stone_pickaxe": "Steispitzhacke",
  "item.minecraft.stone_shovel": "Steischufle",
  "item.minecraft.stone_spear": "Steispeer",
  "item.minecraft.stone_sword": "Steischwert",
  "item.minecraft.stray_spawn_egg": "Iiswanderer-Spawn-Ei",
  "item.minecraft.strider_spawn_egg": "Schriter-Spawn-Ei",
  "item.minecraft.string": "Fade",
  "item.minecraft.sugar": "Zucker",
  "item.minecraft.suspicious_stew": "Seltsami Suppe",
  "item.minecraft.sweet_berries": "Süessbeeri",
  "item.minecraft.tadpole_bucket": "Gugermöndlichübel",
  "item.minecraft.tadpole_spawn_egg": "Gugermöndli-Spawn-Ei",
  "item.minecraft.tide_armor_trim_smithing_template": "Schmiedvorlag",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Gezeite-Rüstigsbesatz",
  "item.minecraft.tipped_arrow": "Tränkte Pfiil",
  "item.minecraft.tipped_arrow.effect.awkward": "Tränkte Pfiil",
  "item.minecraft.tipped_arrow.effect.empty": "Nöd herstellbare tränkte Pfiil",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Pfiil vode Füürresistenz",
  "item.minecraft.tipped_arrow.effect.harming": "Pfiil vom Schade",
  "item.minecraft.tipped_arrow.effect.healing": "Pfiil vode Heilig",
  "item.minecraft.tipped_arrow.effect.infested": "Pfiil vom Befall",
  "item.minecraft.tipped_arrow.effect.invisibility": "Pfiil vode Unsichtbarkeit",
  "item.minecraft.tipped_arrow.effect.leaping": "Pfiil vode Sprungchraft",
  "item.minecraft.tipped_arrow.effect.levitation": "Pfiil vode Schwebechraft",
  "item.minecraft.tipped_arrow.effect.luck": "Pfiil vom Glück",
  "item.minecraft.tipped_arrow.effect.mundane": "Tränkte Pfiil",
  "item.minecraft.tipped_arrow.effect.night_vision": "Pfiil vode Nachtsicht",
  "item.minecraft.tipped_arrow.effect.oozing": "Pfiil vom Schliime",
  "item.minecraft.tipped_arrow.effect.poison": "Pfiil vode Vergiftig",
  "item.minecraft.tipped_arrow.effect.regeneration": "Pfiil vode Regeneration",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Pfiil vom sanfte Fall",
  "item.minecraft.tipped_arrow.effect.slowness": "Pfiil vode Langsamkeit",
  "item.minecraft.tipped_arrow.effect.strength": "Pfiil vode Stärki",
  "item.minecraft.tipped_arrow.effect.swiftness": "Pfiil vode Schnelligkeit",
  "item.minecraft.tipped_arrow.effect.thick": "Tränkte Pfiil",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Pfiil vom Schildchrotemeister",
  "item.minecraft.tipped_arrow.effect.water": "Nasse Pfiil",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Pfiil vode Unterwasseratmig",
  "item.minecraft.tipped_arrow.effect.weakness": "Pfiil vode Schwächi",
  "item.minecraft.tipped_arrow.effect.weaving": "Pfiil vom Webe",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Pfiil vode Windladig",
  "item.minecraft.tnt_minecart": "TNT-Lore",
  "item.minecraft.torchflower_seeds": "Fackelliliesame",
  "item.minecraft.totem_of_undying": "Totem vode Unsterblichkeit",
  "item.minecraft.trader_llama_spawn_egg": "Händlerlama-Spawn-Ei",
  "item.minecraft.trial_key": "Prüefigsschlüssel",
  "item.minecraft.trident": "Drüzack",
  "item.minecraft.tropical_fish": "Tropefisch",
  "item.minecraft.tropical_fish_bucket": "Tropefischchübel",
  "item.minecraft.tropical_fish_spawn_egg": "Tropefisch-Spawn-Ei",
  "item.minecraft.turtle_helmet": "Schildchrotepanzer",
  "item.minecraft.turtle_scute": "Schildchrot-Hornschild",
  "item.minecraft.turtle_spawn_egg": "Schildchrote-Spawn-Ei",
  "item.minecraft.vex_armor_trim_smithing_template": "Schmiedvorlag",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Plagegeister-Rüstigsbesatz",
  "item.minecraft.vex_spawn_egg": "Plagegeister-Spawn-Ei",
  "item.minecraft.villager_spawn_egg": "Dorfbewohner-Spawn-Ei",
  "item.minecraft.vindicator_spawn_egg": "Diener-Spawn-Ei",
  "item.minecraft.wandering_trader_spawn_egg": "Fahrende-Händler-Spawn-Ei",
  "item.minecraft.ward_armor_trim_smithing_template": "Schmiedvorlag",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Warthof-Rüstigsbesatz",
  "item.minecraft.warden_spawn_egg": "Wärter-Spawn-Ei",
  "item.minecraft.warped_fungus_on_a_stick": "Wirrpilzruete",
  "item.minecraft.water_bucket": "Wasserchübel",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Schmiedvorlag",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wegfinder-Rüstigsbesatz",
  "item.minecraft.wheat": "Weize",
  "item.minecraft.wheat_seeds": "Weizechörner",
  "item.minecraft.white_bundle": "Wiisses Bündel",
  "item.minecraft.white_dye": "Wiisse Farbstoff",
  "item.minecraft.white_harness": "Wiisses Gschirr",
  "item.minecraft.wild_armor_trim_smithing_template": "Schmiedvorlag",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wildnis-Rüstigsbesatz",
  "item.minecraft.wind_charge": "Windchugle",
  "item.minecraft.witch_spawn_egg": "Hex-Spawn-Ei",
  "item.minecraft.wither_skeleton_spawn_egg": "Wither-Skelett-Spawn-Ei",
  "item.minecraft.wither_spawn_egg": "Wither-Spawn-Ei",
  "item.minecraft.wolf_armor": "Wolfsrüstig",
  "item.minecraft.wolf_spawn_egg": "Wolf-Spawn-Ei",
  "item.minecraft.wooden_axe": "Holzaxt",
  "item.minecraft.wooden_hoe": "Holzhacke",
  "item.minecraft.wooden_pickaxe": "Holzspitzhacke",
  "item.minecraft.wooden_shovel": "Holzschufle",
  "item.minecraft.wooden_spear": "Holzspeer",
  "item.minecraft.wooden_sword": "Holzschwert",
  "item.minecraft.writable_book": "Buech und Federe",
  "item.minecraft.written_book": "Gschribenes Buech",
  "item.minecraft.yellow_bundle": "Gelbs Bündel",
  "item.minecraft.yellow_dye": "Gelbe Farbstoff",
  "item.minecraft.yellow_harness": "Gelbs Gschirr",
  "item.minecraft.zoglin_spawn_egg": "Zoglin-Spawn-Ei",
  "item.minecraft.zombie_horse_spawn_egg": "Zombieross-Spawn-Ei",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombienautilus-Spawn-Ei",
  "item.minecraft.zombie_spawn_egg": "Zombie-Spawn-Ei",
  "item.minecraft.zombie_villager_spawn_egg": "Zombiedorfbewohner-Spawn-Ei",
  "item.minecraft.zombified_piglin_spawn_egg": "Zombifizierte-Piglin-Spawn-Ei"
}
export const de_ch = items; 
